var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChemistAmico1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-103",
    d: "M80.54,444.23c-93.6-54-93.6-141.64,0-195.68s245.33-54,338.93,0,93.59,141.65,0,195.68S174.13,498.27,80.54,444.23Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-103",
    d: "M279.36,283.08,463,389.05c1.27.74,1.27,1.93,0,2.67l-81.7,47.17a5.11,5.11,0,0,1-4.63,0L193,332.91c-1.28-.74-1.28-1.93,0-2.67l81.69-47.16A5.11,5.11,0,0,1,279.36,283.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-103",
    cx: 85.9,
    cy: 367.32,
    rx: 52.01,
    ry: 30.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-103",
    cx: 159.44,
    cy: 408.6,
    rx: 65.17,
    ry: 37.63,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-103"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "53.1 215.84 53.1 218.46 115 182.7 112.97 181.22 53.1 215.84",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.97 181.22 53.1 215.84 53.1 75.44 112.97 40.82 112.97 181.22",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.06,32.64,49,73.09V225.5l70-40.46ZM115,182.7,53.1,218.46v-143L115,39.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115 182.7 112.97 181.22 112.97 40.82 115 39.67 115 182.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.06 32.64 117.03 31.46 47.01 71.92 49.03 73.09 119.06 32.64",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.01 71.92 49.03 73.09 49.03 225.5 47.01 224.33 47.01 71.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.1 145.43 112.96 110.77 115 111.99 53.1 147.75 53.1 145.43",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115 111.99 115 116.53 53.09 152.29 53.1 147.75 115 111.99",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Blinds--inject-103"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "53.1 78.83 112.97 44.23 114.03 48.99 53.1 84.25 53.1 78.83",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.1 78.83 53.1 81.01 113.39 46.12 112.97 44.23 53.1 78.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.1 86.41 112.97 51.81 114.03 56.56 53.1 91.82 53.1 86.41",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.1 86.41 53.1 88.58 113.39 53.7 112.97 51.81 53.1 86.41",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.1 93.98 112.97 59.38 114.03 64.14 53.1 99.4 53.1 93.98",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.1 93.98 53.1 96.16 113.39 61.27 112.97 59.38 53.1 93.98",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.1 101.56 112.97 66.96 114.03 71.72 53.1 106.98 53.1 101.56",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.1 101.56 53.1 103.74 113.39 68.85 112.97 66.96 53.1 101.56",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.1 109.14 112.97 74.54 114.03 79.29 53.1 114.55 53.1 109.14",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.1 109.14 53.1 111.31 113.39 76.42 112.97 74.54 53.1 109.14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.1 116.72 112.97 82.11 114.03 86.87 53.1 122.13 53.1 116.72",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.1 116.72 53.1 118.89 113.39 84 112.97 82.11 53.1 116.72",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.1 124.29 112.97 89.69 114.03 94.45 53.1 129.71 53.1 124.29",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.1 124.29 53.1 126.47 113.39 91.58 112.97 89.69 53.1 124.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.1 131.87 112.97 97.27 114.03 102.02 53.1 137.28 53.1 131.87",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.1 131.87 53.1 134.04 113.39 99.16 112.97 97.27 53.1 131.87",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Diploma--inject-103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--diploma--inject-103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-103"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "344.74 90.76 343.05 91.73 300.74 67.31 302.43 66.33 344.74 90.76",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.43 66.33 343.05 89.78 343.05 54.57 302.43 31.12 302.43 66.33",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.05,68.28l45.69,26.39V53.6L299.05,27.21Zm1.69-38.13,42.31,24.42V91.73L300.74,67.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.74 67.31 302.43 66.33 302.43 31.12 300.74 30.15 300.74 67.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.05 27.21 300.74 26.24 346.44 52.62 344.74 53.6 299.05 27.21",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.44 52.62 344.74 53.6 344.74 94.67 346.44 93.69 346.44 52.62",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.91,74a6.32,6.32,0,0,1,2.86,5c0,1.82-1.28,2.56-2.86,1.65a6.33,6.33,0,0,1-2.85-4.95C330.06,73.86,331.34,73.12,332.91,74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,41.12l21.51,12.41a2.39,2.39,0,0,1,1.08,1.87v.06c0,.69-.49,1-1.08.63L312,43.69a2.38,2.38,0,0,1-1.09-1.87v-.08C310.91,41.05,311.4,40.77,312,41.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.59,47,336.9,63.32a2.16,2.16,0,0,1,1.09,1.6c0,.54-.49.7-1.09.35L308.57,48.92a2.12,2.12,0,0,1-1.07-1.6C307.5,46.78,308,46.63,308.59,47Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.59,50.88,336.9,67.22A2.19,2.19,0,0,1,338,68.83c0,.54-.49.69-1.09.35L308.57,52.82a2.11,2.11,0,0,1-1.07-1.6C307.5,50.69,308,50.53,308.59,50.88Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.59,54.78,336.9,71.13a2.16,2.16,0,0,1,1.09,1.6c0,.54-.49.7-1.09.35L308.57,56.72a2.11,2.11,0,0,1-1.07-1.59C307.5,54.59,308,54.44,308.59,54.78Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.23,76.38a3.59,3.59,0,0,1-.7-.64,2,2,0,0,1-.53-1.65c0-.18-.26-.78-.4-.69a10.21,10.21,0,0,1-1.23.5c-.24.12-.7.48-1.28-.32a1.67,1.67,0,0,1-.32-1,1.45,1.45,0,0,0,.38-1.33c0-.2-.34-.79-.43-.65a2.31,2.31,0,0,0-.37,1.2,2.09,2.09,0,0,1-.92.3,2.22,2.22,0,0,1-.58.12c-.05,0-.16,0-.24,0a.55.55,0,0,1-.2-.45.72.72,0,0,1,.09-.47h0l0,0v0c0-.2-.25-.76-.35-.64a1.75,1.75,0,0,1-1.66.85.45.45,0,0,1-.11,0c0-.12,0-.27,0-.39a4.79,4.79,0,0,0-.14-.92c0-.18-.26-.62-.37-.59-.6.18-1.08.65-1.89.43a2,2,0,0,1-.39-.18c-.13-.22.07-.68.09-.75a4,4,0,0,1,.28-.59,1,1,0,0,0,.23-.49c0-.19-.37-1-.44-.78s-.14.28-.26.52a3.84,3.84,0,0,1-1.59.85,2.43,2.43,0,0,1-2.21-.42,2.84,2.84,0,0,1-1-1,2.47,2.47,0,0,1-.25-1.1,4.17,4.17,0,0,1,.26-1.65,8.35,8.35,0,0,0,2.45,1.1,2.58,2.58,0,0,0,1.86.09c.25-.16.4-.74-.21-1.7a3.65,3.65,0,0,0-1.32-1.21,3.56,3.56,0,0,0-1.35-.51,1.67,1.67,0,0,0-1.69,1.14c-.05.11-.12.27-.19.45a13.45,13.45,0,0,1-3.12-3.08c-.05-.07-.08,0,0,.11a15.07,15.07,0,0,0,3.05,3.23,4.22,4.22,0,0,0,.68,3.84c1.17,1.68,2.43,1.73,3,1.62a2.51,2.51,0,0,0,1.18-.54s.07,0,.11,0a2,2,0,0,0,.64,1.61,1.18,1.18,0,0,0,1.34.26,4.59,4.59,0,0,0,.81-.29,2.44,2.44,0,0,0,.61,1.67c.45.43.86.08,1.08,0a2.1,2.1,0,0,0,.54-.27,2,2,0,0,0,.1.29c.4.87.86,1,1.11.92a5.21,5.21,0,0,0,1.11-.23,3.89,3.89,0,0,0,.47,1.07c.6,1,1.17,1.14,1.52,1.09a2.57,2.57,0,0,0,1.14-.51,3.38,3.38,0,0,0,.41,1.06A4.28,4.28,0,0,0,327.43,77C327.61,77.12,327.43,76.5,327.23,76.38ZM314,63.44c.28.19.86.62.89,1.13,0,.3-.23.34-.38.39a3.43,3.43,0,0,1-1.64-.15,8.91,8.91,0,0,1-2.07-.81C311.31,62.83,312.31,62.35,314,63.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Furniture--inject-103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.27,420.51H373.64l1.7,10.37h0a1.86,1.86,0,0,0,1,1.28,5.68,5.68,0,0,0,5.14,0,1.89,1.89,0,0,0,1-1.28h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,325.66H209.35l1.7,10.37h0a1.94,1.94,0,0,0,1,1.28,5.7,5.7,0,0,0,5.15,0,1.91,1.91,0,0,0,1-1.28h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.1,381.35H441.47l1.7,10.38h0a1.93,1.93,0,0,0,1,1.28,5.7,5.7,0,0,0,5.15,0,1.93,1.93,0,0,0,1-1.28h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.72 242.29 454.72 385.94 378.9 429.72 378.9 286.07 454.72 242.29",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.9 429.72 202.94 328.13 202.94 184.48 378.9 286.07 378.9 429.72",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.94,186.21l174,100.43V428l-174-100.43V186.21m-1-1.73V328.13l176,101.59V286.07l-176-101.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.06 400.94 326.97 399.74 326.97 256.08 329.06 257.29 329.06 400.94",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.78 359.79 255.69 358.58 255.69 214.93 257.78 216.14 257.78 359.79",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.4,185.19a1.58,1.58,0,0,1,.93-1.3l79.33-45.8a5,5,0,0,1,4.49,0L460.47,241a1.56,1.56,0,0,1,.93,1.29v3a1.58,1.58,0,0,1-.93,1.3l-79.33,45.8a4.94,4.94,0,0,1-4.49,0l-178.32-103a1.58,1.58,0,0,1-.93-1.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.4,185.19a1.58,1.58,0,0,1,.93-1.3l79.33-45.8a5,5,0,0,1,4.49,0L460.47,241a1.56,1.56,0,0,1,.93,1.29v3a1.58,1.58,0,0,1-.93,1.3l-79.33,45.8a4.94,4.94,0,0,1-4.49,0l-178.32-103a1.58,1.58,0,0,1-.93-1.29Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4,242.29v3a1.58,1.58,0,0,1-.93,1.3l-79.33,45.8a4.56,4.56,0,0,1-2.24.54V220.7l30.56-9.14,51,29.44A1.56,1.56,0,0,1,461.4,242.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.15,138.09,460.47,241c1.24.71,1.24,1.87,0,2.59l-79.33,45.8a4.94,4.94,0,0,1-4.49,0L198.33,186.48c-1.24-.71-1.24-1.87,0-2.59l79.33-45.8A5,5,0,0,1,282.15,138.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.15,138.09,460.47,241c1.24.71,1.24,1.87,0,2.59l-79.33,45.8a4.94,4.94,0,0,1-4.49,0L198.33,186.48c-1.24-.71-1.24-1.87,0-2.59l79.33-45.8A5,5,0,0,1,282.15,138.09Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M363,294.3c0,.72-2.16.06-4.82-1.48l-6.35-3.66c-2.67-1.53-4.82-3.38-4.82-4.1v-1.3L363,293Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,220.42c0,.72-2.15.06-4.82-1.48l-6.35-3.66c-2.66-1.53-4.82-3.38-4.82-4.1v-1.3l16,9.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.15,268.22c0,.72-2.16.06-4.82-1.48L290,263.09c-2.66-1.54-4.82-3.38-4.82-4.1v-1.31l16,9.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.15,295.93c0,.72-2.16.06-4.82-1.48L290,290.79c-2.66-1.53-4.82-3.38-4.82-4.1v-1.3l16,9.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.15,335.71c0,.72-2.16.06-4.82-1.48L290,330.58c-2.66-1.54-4.82-3.38-4.82-4.1v-1.31l16,9.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.73 259.74 328.35 301.09 328.35 303.4 256.73 262.05 256.73 259.74",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.73 299.53 328.35 340.88 328.35 343.18 256.73 301.84 256.73 299.53",
    style: {
      fill: "#e6e6e6"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Microscope--inject-103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--microscope--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-103",
    d: "M358,232.05l-25.07-14.47a.4.4,0,0,1,0-.75l39.27-22.67a1.42,1.42,0,0,1,1.3,0l25.07,14.47a.4.4,0,0,1,0,.75l-39.27,22.67A1.42,1.42,0,0,1,358,232.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--microscope--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.39,207v2.35l-33.16,19.15v-2.35c0-1.3,1.29-3.1,2.89-4l27.37-15.81a2.57,2.57,0,0,1,2.34-.38A1.1,1.1,0,0,1,392.39,207Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.92,195l-.05,0h0a2.51,2.51,0,0,0-2.37.37l-27.37,15.81c-1.6.92-2.89,2.72-2.89,4v2.35l19,11v-2.35c0-1.3,1.29-3.1,2.89-4l27.37-15.81a2.57,2.57,0,0,1,2.34-.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.48,208.25a15.24,15.24,0,0,1,8.43-1.67L371.4,200l8.85,5.11-11.48,6.63c.36,1.73-.6,3.54-2.9,4.86a15.87,15.87,0,0,1-14.39,0C347.51,214.26,347.51,210.54,351.48,208.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.37,199.92v3.91l-6.78,3.92v-3.92A7.5,7.5,0,0,1,379,198a2.36,2.36,0,0,1,2.42-.23A2.41,2.41,0,0,1,382.37,199.92Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.37,199.92v3.91l-6.78,3.92v-3.92A7.5,7.5,0,0,1,379,198a2.36,2.36,0,0,1,2.42-.23A2.41,2.41,0,0,1,382.37,199.92Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.29,193.05l-.06,0a2.39,2.39,0,0,0-2.38.25,7.48,7.48,0,0,0-3.4,5.87v3.92l8.14,4.7v-3.92A7.5,7.5,0,0,1,379,198a2.42,2.42,0,0,1,2.32-.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.29,193.05l-.06,0a2.39,2.39,0,0,0-2.38.25,7.48,7.48,0,0,0-3.4,5.87v3.92l8.14,4.7v-3.92A7.5,7.5,0,0,1,379,198a2.42,2.42,0,0,1,2.32-.28Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,201.39c.5-.28.91,0,.91.53a2,2,0,0,1-.91,1.57c-.5.28-.9,0-.9-.53A2,2,0,0,1,379,201.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.6,165.44l2.06-3.44s-4.83-2.76-6.31-3.64l-2.45,3.39c3.3,3.05,6.41,10.49,5,18.95-.79,4.86-2.51,8.56-5.62,13.45l6.3,3.64a34.58,34.58,0,0,0,6.5-12.95C385.93,178.92,384.49,168.67,378.6,165.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.6,165.45c2.18,1.3,6.84,7.39,5.31,18-.7,4.88-3.57,9.3-6.3,14.34q.25-.18.51-.33a2.36,2.36,0,0,1,2.42-.23l.86.5a1.55,1.55,0,0,1,.52.49,35.29,35.29,0,0,0,6.42-17.32c.76-11.06-4.35-16.91-7.68-18.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.66,162a11.77,11.77,0,0,0-5.6-1.56l-.64,3.71s1.65-.27,4.18,1.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.76 207.98 364.76 204.85 355.91 199.74 355.91 202.87 364.76 207.98",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.76 207.98 364.76 204.85 355.91 199.74 355.91 202.87 364.76 207.98",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.76 207.98 380.25 199.04 380.25 195.91 364.76 204.85 364.76 207.98",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.76 207.98 380.25 199.04 380.25 195.91 364.76 204.85 364.76 207.98",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.91 199.74 371.4 190.8 380.25 195.91 364.76 204.85 355.91 199.74",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.51,206.13v-2.87c0-1.51,1-3,3-4.16a15.93,15.93,0,0,1,14.39,0c2,1.15,3,2.65,3,4.15h0v2.88h0c0,1.52-1,3.05-3,4.21a15.93,15.93,0,0,1-14.39,0c-2-1.16-3-2.69-3-4.21Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.51,206.13v-2.87c0-1.51,1-3,3-4.16a15.93,15.93,0,0,1,14.39,0c2,1.15,3,2.65,3,4.15h0v2.88h0c0,1.52-1,3.05-3,4.21a15.93,15.93,0,0,1-14.39,0c-2-1.16-3-2.69-3-4.21Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.87,199.1a15.93,15.93,0,0,0-14.39,0c-4,2.3-4,6,0,8.31a15.93,15.93,0,0,0,14.39,0C369.84,205.11,369.84,201.4,365.87,199.1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.05,203.1v-2.16a3.79,3.79,0,0,1,2.23-3.11,11.93,11.93,0,0,1,10.79,0,3.79,3.79,0,0,1,2.23,3.11h0v2.16h0c0,1.14-.72,2.28-2.23,3.16a11.93,11.93,0,0,1-10.79,0c-1.51-.88-2.25-2-2.23-3.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.07,197.83a11.93,11.93,0,0,0-10.79,0c-3,1.72-3,4.51,0,6.23a11.93,11.93,0,0,0,10.79,0C367.05,202.34,367.05,199.55,364.07,197.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.76,198a11.25,11.25,0,0,0-10.17,0c-2.81,1.62-2.81,4.25,0,5.87a11.25,11.25,0,0,0,10.17,0C366.57,202.26,366.57,199.63,363.76,198Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.59,200a11.25,11.25,0,0,1,10.17,0,4.39,4.39,0,0,1,1.9,1.94,4.39,4.39,0,0,1-1.9,1.94,11.25,11.25,0,0,1-10.17,0,4.39,4.39,0,0,1-1.9-1.94A4.39,4.39,0,0,1,353.59,200Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,201.19a2.88,2.88,0,0,0-2.59,0,.79.79,0,0,0,0,1.49,2.82,2.82,0,0,0,2.59,0A.79.79,0,0,0,360,201.19Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.7,202.7a.93.93,0,0,0-.8,0c-.23.13-.23.34,0,.47a.93.93,0,0,0,.8,0A.25.25,0,0,0,356.7,202.7Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 358.05,
    cy: 201.58,
    rx: 0.63,
    ry: 0.36,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,202.82c0,.06.08.11.19.11s.19-.05.19-.11-.08-.11-.19-.11S356,202.76,356,202.82Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.36,185.49v-8l-5.53,0v7.95h0a1.36,1.36,0,0,0,.81,1.12,4.31,4.31,0,0,0,3.91,0A1.37,1.37,0,0,0,355.36,185.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.83,183.85a1.37,1.37,0,0,0,.81,1.13,4.31,4.31,0,0,0,3.91,0,1.37,1.37,0,0,0,.81-1.13v1.66a1.37,1.37,0,0,1-.81,1.13,4.31,4.31,0,0,1-3.91,0,1.36,1.36,0,0,1-.81-1.12h0v-1.66Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.83,183.85a1.37,1.37,0,0,0,.81,1.13,4.31,4.31,0,0,0,3.91,0,1.37,1.37,0,0,0,.81-1.13v1.66a1.37,1.37,0,0,1-.81,1.13,4.31,4.31,0,0,1-3.91,0,1.36,1.36,0,0,1-.81-1.12h0v-1.66Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,185.49v-8l5.53,0v7.95h0a1.35,1.35,0,0,1-.82,1.12,4.31,4.31,0,0,1-3.91,0A1.36,1.36,0,0,1,362,185.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.51,183.85a1.37,1.37,0,0,1-.82,1.13,4.31,4.31,0,0,1-3.91,0,1.36,1.36,0,0,1-.8-1.13v1.66a1.36,1.36,0,0,0,.8,1.13,4.31,4.31,0,0,0,3.91,0,1.35,1.35,0,0,0,.82-1.12h0v-1.66Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.51,183.85a1.37,1.37,0,0,1-.82,1.13,4.31,4.31,0,0,1-3.91,0,1.36,1.36,0,0,1-.8-1.13v1.66a1.36,1.36,0,0,0,.8,1.13,4.31,4.31,0,0,0,3.91,0,1.35,1.35,0,0,0,.82-1.12h0v-1.66Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.44,189v-7.94h-5.53V189h0a1.37,1.37,0,0,0,.81,1.13,4.36,4.36,0,0,0,3.92,0A1.4,1.4,0,0,0,361.44,189Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.91,187.35a1.37,1.37,0,0,0,.81,1.13,4.33,4.33,0,0,0,3.92,0,1.38,1.38,0,0,0,.8-1.13V189a1.4,1.4,0,0,1-.8,1.14,4.36,4.36,0,0,1-3.92,0,1.37,1.37,0,0,1-.81-1.13h0v-1.66Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.27,170.62a4.07,4.07,0,0,1,1.83-3.18,11.43,11.43,0,0,0,1.95-1.92l2.65-3.22a12.54,12.54,0,0,1,13.24-4.15,10.85,10.85,0,0,1,2.2.93c1.95,1.12,2.83,2.63,2.64,4.1v9.23c.11,1.42-.76,2.85-2.63,3.94l-6.4,3.7a14.19,14.19,0,0,1-12.82,0c-1.77-1-2.66-2.35-2.67-3.68S349.28,172,349.27,170.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.4 173.66 369.19 174.94 369.19 173.66 371.4 172.38 371.4 173.66",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.38,171.08a12.55,12.55,0,0,1-13.24,4.15,10.1,10.1,0,0,1-2.2-.93c-3.25-1.86-3.53-4.8-.83-6.86a11.74,11.74,0,0,0,1.94-1.92l2.65-3.22a12.54,12.54,0,0,1,13.24-4.15,10.85,10.85,0,0,1,2.2.93c3.25,1.86,3.53,4.8.83,6.86a12.22,12.22,0,0,0-2,1.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.94,179a14.19,14.19,0,0,0,12.82,0l6.4-3.7c1.77-1,2.65-2.37,2.64-3.71v1.11c0,1.34-.87,2.68-2.64,3.71l-6.4,3.7a14.19,14.19,0,0,1-12.82,0c-1.77-1-2.66-2.35-2.67-3.68V175.3C349.28,176.63,350.17,178,351.94,179Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.81,162.77v-6.29l-18.13.06v6.29h0c0,1.34.9,2.68,2.67,3.69a14.13,14.13,0,0,0,12.82,0C372.93,165.45,373.81,164.11,373.81,162.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.67,156.54l18.13-.06s0,.06,0,1.4-.87,2.68-2.64,3.71a14.16,14.16,0,0,1-12.82,0c-1.77-1-2.66-2.35-2.67-3.69S355.67,156.54,355.67,156.54Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.31,152.83a14.18,14.18,0,0,1,12.83,0c3.54,2,3.55,5.35,0,7.4a14.13,14.13,0,0,1-12.82,0C354.79,158.2,354.78,154.88,358.31,152.83Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.31,152.83a14.18,14.18,0,0,1,12.83,0c3.54,2,3.55,5.35,0,7.4a14.13,14.13,0,0,1-12.82,0C354.79,158.2,354.78,154.88,358.31,152.83Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.66,156V144.72l-7.84,0V156h0A2,2,0,0,0,362,157.6a6.11,6.11,0,0,0,5.54,0A1.94,1.94,0,0,0,368.66,156Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.82,144.74l7.84,0v1.65a1.94,1.94,0,0,1-1.14,1.6,6.11,6.11,0,0,1-5.54,0,1.94,1.94,0,0,1-1.15-1.6C360.82,145.81,360.82,144.74,360.82,144.74Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,143.14a6.11,6.11,0,0,1,5.54,0c1.54.88,1.54,2.31,0,3.2a6.11,6.11,0,0,1-5.54,0C360.44,145.46,360.44,144,362,143.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,143.14a6.11,6.11,0,0,1,5.54,0c1.54.88,1.54,2.31,0,3.2a6.11,6.11,0,0,1-5.54,0C360.44,145.46,360.44,144,362,143.14Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.74,143.59a4.42,4.42,0,0,1,4,0,1.22,1.22,0,0,1,0,2.31,4.45,4.45,0,0,1-4,0A1.21,1.21,0,0,1,362.74,143.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.73,145.2a2,2,0,0,1,.45.34,2.68,2.68,0,0,1-.44.34,4.45,4.45,0,0,1-4,0,2.4,2.4,0,0,1-.45-.34,2.68,2.68,0,0,1,.44-.34A4.42,4.42,0,0,1,366.73,145.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.62,145.36c0,.15.12.31.33.36a.35.35,0,0,0,.44-.2c0-.15-.11-.31-.32-.35A.36.36,0,0,0,365.62,145.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.13,145.19a.15.15,0,0,0,.3.06.15.15,0,1,0-.3-.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,158.1a2.06,2.06,0,0,0-2.14.18,5.56,5.56,0,0,0-1.28,1.07l-.27.33v0a7,7,0,0,0-1.12,2.09,5.07,5.07,0,0,0-.29,1.64,2.13,2.13,0,0,0,.83,1.9l1,.57a1.39,1.39,0,0,1-.4-.37,2.53,2.53,0,0,1-.43-1.53,6.59,6.59,0,0,1,3-5.15,2.55,2.55,0,0,1,1.55-.39,1.67,1.67,0,0,1,.58.2h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,158.1a2.06,2.06,0,0,0-2.14.18,5.56,5.56,0,0,0-1.28,1.07l-.27.33v0a7,7,0,0,0-1.12,2.09,5.07,5.07,0,0,0-.29,1.64,2.13,2.13,0,0,0,.83,1.9l1,.57a1.39,1.39,0,0,1-.4-.37,2.53,2.53,0,0,1-.43-1.53,6.59,6.59,0,0,1,3-5.15,2.55,2.55,0,0,1,1.55-.39,1.67,1.67,0,0,1,.58.2h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,158.66a1.67,1.67,0,0,0-.58-.2,2.55,2.55,0,0,0-1.55.39,6.59,6.59,0,0,0-3,5.15,2.53,2.53,0,0,0,.43,1.53,1.39,1.39,0,0,0,.4.37l0,0a1.49,1.49,0,0,0,.82.19,2.74,2.74,0,0,0,1.27-.4,6.58,6.58,0,0,0,3-5.15A2.11,2.11,0,0,0,377,158.66Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,158.66a1.67,1.67,0,0,0-.58-.2,2.55,2.55,0,0,0-1.55.39,6.59,6.59,0,0,0-3,5.15,2.53,2.53,0,0,0,.43,1.53,1.39,1.39,0,0,0,.4.37l0,0a1.49,1.49,0,0,0,.82.19,2.74,2.74,0,0,0,1.27-.4,6.58,6.58,0,0,0,3-5.15A2.11,2.11,0,0,0,377,158.66Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.87,160.9c.66-.38,1.2-.07,1.2.7a2.65,2.65,0,0,1-1.2,2.07c-.66.38-1.19.07-1.19-.69A2.66,2.66,0,0,1,374.87,160.9Z",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-103",
    d: "M339.9,197.55l10-5.74c1.49-.86,1.49-2.26,0-3.13l-71.39-41.21a5.93,5.93,0,0,0-5.41,0l-9.95,5.74c-1.5.86-1.5,2.26,0,3.13l71.39,41.21A5.93,5.93,0,0,0,339.9,197.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-103",
    d: "M305.09,197.64,285.5,209.05a2.27,2.27,0,0,1-2.09,0l-55.1-31.77a.63.63,0,0,1,0-1.2l19.59-11.41a2.27,2.27,0,0,1,2.09,0l55.11,31.77A.63.63,0,0,1,305.09,197.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keyboard--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.81,173.74a.71.71,0,0,1,.43-.6l17.44-10.07a2.31,2.31,0,0,1,2.08,0L303,193.84a.76.76,0,0,1,.43.6v1.83a.73.73,0,0,1-.43.6l-17.43,10.07a2.28,2.28,0,0,1-2.08,0l-53.22-30.72a.73.73,0,0,1-.43-.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.54,205.06,303,195a.63.63,0,0,0,0-1.2l-53.21-30.77a2.31,2.31,0,0,0-2.08,0l-17.44,10.07a.63.63,0,0,0,0,1.2l53.22,30.72A2.31,2.31,0,0,0,285.54,205.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.56,205.31v1.87a2.18,2.18,0,0,0,1-.24L303,196.87a.73.73,0,0,0,.44-.6v-1.83a.74.74,0,0,1-.44.6l-17.42,10A2.06,2.06,0,0,1,284.56,205.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.06,173.81v0l1.73-1,2.34,1.35-1.73,1-2.34-1.35Zm2.7-1.56,0,0,1.72-1,1.84,1.06-1.74,1-1.83-1.06Zm.57,3.45,0,0,1.72-1,1.84,1.06-1.74,1-1.83-1.06Zm2.14-5s0,0,0,0l1.72-1,3,1.72-1.73,1-3-1.72Zm.06,3.16s0,0,0,0l1.73-1,1.46.84-1.74,1-1.45-.84Zm.57,3.44v0l1.73-1,1.84,1.06-1.74,1-1.83-1.06Zm1.82-2.06,0,0,1.72-1,1.46.84-1.74,1-1.45-.84Zm.25-6.1v0l1.73-1,2.34,1.35-1.74,1-2.34-1.35Zm.7,9.76v0l1.73-1,13.28,7.68-1.73,1-13.29-7.67Zm.5-5.95s0,0,0,0l1.72-1,1.46.85-1.73,1-1.46-.85Zm.94,3.67s0,0,0,0l1.72-1,1.46.84-1.74,1-1.45-.84Zm.56-9v0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.57,3.45a0,0,0,0,1,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.32,3.3v0l1.72-1,1.46.85-1.73,1-1.46-.85Zm.94,3.67s0,0,0,0l1.72-1,1.46.84-1.74,1-1.45-.84Zm.56-9v0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.57,3.45a0,0,0,0,1,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.32,3.3v0l1.73-1,1.46.85-1.74,1-1.46-.85Zm0-10s0,0,0,0l1.73-1,1.83,1.06-1.73,1-1.84-1.06Zm.94,13.69,0,0,1.72-1,1.46.84-1.73,1-1.46-.84Zm.56-9a0,0,0,0,1,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.57,3.45v0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.32,3.3a0,0,0,0,1,0,0l1.73-1,1.46.85-1.74,1-1.46-.85Zm.94,3.67,0,0,1.72-1,1.46.84-1.73,1-1.46-.84Zm.48-12.88s0,0,0,0l1.72-1,1.46.84-1.73,1-1.46-.84Zm.08,3.84a0,0,0,0,1,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.57,3.45v0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.32,3.3a0,0,0,0,1,0,0l1.73-1,1.46.85-1.74,1-1.46-.85Zm.94,3.67,0,0,1.72-1,1.46.84-1.74,1-1.45-.84Zm.48-12.87s0,0,0,0l1.72-1,1.47.84-1.74,1-1.46-.84Zm.08,3.83v0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.57,3.45v0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.32,3.3v0l1.73-1,1.46.85-1.74,1-1.46-.85Zm1,3.67s0,0,0,0l1.72-1,1.46.84-1.73,1-1.46-.84Zm.47-12.88s0,0,0,0l1.72-1,1.47.84-1.74,1-1.46-.84Zm.08,3.84v0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.27,12.63s0,0,0,0l1.72-1,1.84,1.06-1.74,1-1.83-1.06Zm.3-9.18v0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.32,3.3v0l1.73-1,1.46.85-1.74,1-1.46-.85Zm1,3.67a0,0,0,0,1,0,0l1.72-1,1.46.84-1.73,1-1.46-.84Zm.47-12.88v0l1.72-1,1.47.84-1.74,1-1.46-.84Zm.08,3.84v0l1.73-1,1.46.84-1.74,1-1.45-.84Zm.57,3.45a0,0,0,0,1,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.07,9.4,0,0,1.72-1,1.84,1.06-1.74,1-1.83-1.06Zm.25-6.1v0l1.73-1,1.46.85-1.74,1-1.46-.85Zm.94,3.67s0,0,0,0l1.72-1,1.46.84-1.73,1-1.46-.84Zm.56-9v0l1.73-1,1.46.84-1.74,1-1.45-.85Zm.57,3.45a0,0,0,0,1,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.32,3.3v0l1.73-1,1.46.85-1.74,1-1.46-.85Zm.07-10s0,0,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.06,16.3s0,0,0,0l1.73-1,1.84,1.06-1.74,1-1.84-1.06Zm.82-2.65s0,0,0,0l1.72-1,1.46.84-1.73,1-1.46-.84Zm.55-9a0,0,0,0,1,0,0l1.72-1,1.46.84-1.74,1-1.45-.84Zm.57,3.45v0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.32,3.3a0,0,0,0,1,0,0l1.73-1,1.46.85-1.74,1-1.46-.85Zm.07-10s0,0,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.44,16.51v0l1.73-1,2.34,1.35-1.74,1-2.34-1.35Zm.44-2.86v0l1.72-1,4.61,2.66-1.74,1-4.6-2.66Zm.55-9a0,0,0,0,1,0,0l1.73-1,1.46.84-1.74,1-1.45-.85Zm.57,3.45v0l1.73-1,1.46.84-1.74,1-1.45-.84Zm.32,3.3a0,0,0,0,1,0,0l1.73-1,1.46.85-1.74,1-1.46-.85Zm.07-10s0,0,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm1.43,4.61v0l1.73-1,1.46.84-1.74,1-1.45-.85Zm.39,12.7v0l1.73-1,1.46.85-1.74,1-1.45-.84Zm.18-9.25v0l1.73-1,1.46.84-1.74,1-1.45-.84Zm.32,3.3v0l1.73-1,1.33.77a.84.84,0,0,0,.42.09,1,1,0,0,0,.45-.09l2.26-1.31,1.71,1-4.43,2.59-3.48-2Zm.07-10s0,0,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm1.43,4.61a0,0,0,0,1,0,0l1.72-1,1.46.84-1.74,1-1.45-.84Zm.39,12.7,0,0,1.72-1,1.46.85-1.74,1-1.45-.84Zm.18-9.25,0,0,1.72-1,1.46.84-1.74,1-1.45-.84Zm1.43-6.08s0,0,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.39,4,0,0,1.72-1,1.46.84L274,185l-1.45-.85Zm.39,12.7a0,0,0,0,1,0,0l1.72-1,1.46.85-1.74,1-1.45-.84Zm.31-2.94,0,0,1.72-1,1.46.85-1.73,1-1.46-.84Zm1.3-12.39s0,0,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.39,4,0,0,1.72-1,2.59,1.5-1.73,1-2.59-1.5Zm.9,13v0l1.73-1,3.85,2.22-1.74,1-3.85-2.22Zm.43-9.11v0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.67-6.51s0,0,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm1.6,14.06v0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.12-6.17a0,0,0,0,1,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.31-2.94a0,0,0,0,1,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.36-3.57s0,0,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm1.29,17v0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.31-2.94v0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.12-6.17a0,0,0,0,1,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.19,3.24a0,0,0,0,1,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.12-6.18a0,0,0,0,1,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.89-3.27v0l1.73-1,1.46.85-1.74,1-1.46-.85Zm.76,16.7v0l4.43-2.55,1.46.84-4.44,2.59-1.46-.84Zm.31-2.94v0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.31-2.93a0,0,0,0,1,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.12-6.18v0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.19,3.24s0,0,0,0l1.73-1,1.46.84-1.74,1-1.45-.84Zm.7-6.51v0l1.73-1,1.46.85-1.74,1-1.46-.85ZM286,198.15a0,0,0,0,1,0,0l1.73-1,1.46.84-1.74,1-1.46-.84Zm.31-2.94s0,0,0,0l1.73-1,1.46.84-1.74,1-1.45-.84Zm.31-2.94s0,0,0,0l1.72-1,1.46.84-1.73,1-1.46-.84Zm.39-3.57v0l1.73-1,1.46.85-1.74,1-1.46-.85Zm1.38,10.83a0,0,0,0,1,0,0l4.43-2.55,1.46.84-4.43,2.59-1.46-.84Zm.31-2.94s0,0,0,0l1.73-1,1.46.84-1.74,1-1.45-.84Zm.31-2.94s0,0,0,0l1.72-1,1.46.84-1.73,1-1.46-.84Zm1.59-3.68v0l.73-.43,1.46.84-.75.46-1.45-.84Zm.8,5.06s0,0,0,0l1.72-1,1.46.84-1.73,1-1.46-.84Zm1.59-3.68v0l.73-.43,1.46.84-.75.46-1.45-.84Zm.8,5.06s0,0,0,0l1.72-1,1.46.84-1.73,1-1.46-.84Zm1.59-3.68v0l.73-.43,1.46.84-.75.46-1.45-.84Zm2.39,1.38a0,0,0,0,1,0,0l.73-.43,1.46.84-.75.46-1.45-.84Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.7,184.68l-11-6.34A2.88,2.88,0,0,1,281,176v-1.52l10.32-5.86a2.41,2.41,0,0,0,1.09-1.89V153.18l19.15,11.07v13.52a2.41,2.41,0,0,1-1.09,1.89l-8.62,5A9.09,9.09,0,0,1,293.7,184.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,180.16v1.52l3.51-2a2.43,2.43,0,0,0,1.1-1.89V164.25L308,162.14l-.24,2.82,2.56,1.48V177a2.39,2.39,0,0,1-1.09,1.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.28,177a2.43,2.43,0,0,1-1.09,1.89l-7.3,4.25a9,9,0,0,1-8.18,0l-11-6.34c-2.26-1.3-2.26-3.42,0-4.72l7.31-4.26a2.41,2.41,0,0,0,1.09-1.89V155.38l19.15,11.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.81,169.12h0l2.23-1.28a2.41,2.41,0,0,0,1.09-1.89V155.38l19.15,11.06V177a2.43,2.43,0,0,1-1.09,1.89L307,180.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.31,191.76a3,3,0,0,1-2.65,0c-9.41-5.44-59.57-34.43-69-39.86a3,3,0,0,1-1.36-2.37V89.87a2.56,2.56,0,0,1,3.92-2.26l69,39.86a3.05,3.05,0,0,1,1.37,2.37v59.6A3,3,0,0,1,341.31,191.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.66,191.71l-69-39.87a3,3,0,0,1-1.36-2.36V89.87c0-.87.61-1.22,1.36-.78l69,39.86a3,3,0,0,1,1.36,2.36v59.61C340,191.79,339.42,192.14,338.66,191.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.47,182.93V132.16a1.84,1.84,0,0,0-.82-1.42l-65-37.53c-.46-.26-.82,0-.82.47v50.77a1.84,1.84,0,0,0,.82,1.42l65,37.53C337.1,183.66,337.47,183.45,337.47,182.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.66,165.86a2.82,2.82,0,0,1,1.28,2.22c0,.82-.57,1.15-1.28.74a2.85,2.85,0,0,1-1.28-2.22C301.38,165.79,302,165.45,302.66,165.86Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.18,128.49,339.62,130a2.93,2.93,0,0,1,.41,1.35v59.78c0,.79-.51,1.15-1.17.89a2.55,2.55,0,0,0,3.73-2.37V129.84A2.78,2.78,0,0,0,342.18,128.49Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mouse--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.06,210l6.39,3.69a7,7,0,0,0,7-.37L328,205.62c1.88-1.37,1.77-3.42-.24-4.59l-3.2-1.85a8.68,8.68,0,0,0-7.4-.23l-13,7.05C302.1,207,302.05,208.83,304.06,210Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.2,202.28,320.91,208l-5.38,4.21a5,5,0,0,1-4.26-.13l-5.71-3.3h0l0,0a4,4,0,0,1-1.15-5.78l.17-.24a7.61,7.61,0,0,1,4.59-2.91l2.9-.58c4.68-.95,8.53-1.41,9-1.11l7.16,4.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.12,205.46l.41-.32-6.42-3.71,5.62-1.74-.57-.33-5.62,1.74-3.83-2.21L313,199Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.17,211.83s0,0,0,0h0l5.11-3.69,6.91-5v-.79a.05.05,0,0,0,0-.05l-.05,0c-.51-.18-3.5.72-7.12,2.16l-2.4,1a7.64,7.64,0,0,0-4.81,7.09v.13a4.67,4.67,0,0,0,1.71-.41Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.52,127.89v-3.68c0-.1.06-.11.18,0l.1.06a.53.53,0,0,1,.11.09.31.31,0,0,1,.07.14l.92,2.85c0,.11.07.26.12.45h0a3.32,3.32,0,0,1,0-.41v-2.28c0-.1.07-.11.19,0l.06,0c.13.07.19.15.19.25V129c0,.09-.06.1-.19,0l-.08-.05a.32.32,0,0,1-.17-.21l-.95-2.94a2.51,2.51,0,0,1-.11-.42h0a3,3,0,0,1,0,.39v2.34c0,.09-.06.1-.19,0l-.06,0Q291.52,128,291.52,127.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.89,124.67V121c0-.1.06-.11.18,0l.1.06.12.09a.46.46,0,0,1,.07.14l.91,2.85a3.46,3.46,0,0,1,.12.45h0a3.19,3.19,0,0,1,0-.42v-2.27c0-.1.06-.11.18,0l.07,0a.29.29,0,0,1,.18.25v3.68q0,.14-.18,0l-.09,0a.32.32,0,0,1-.17-.21l-.95-3a3.27,3.27,0,0,1-.11-.41h0a3,3,0,0,1,0,.39v2.34q0,.14-.18,0l-.07,0Q282.89,124.81,282.89,124.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.89,133.73v-3.67c0-.1.06-.11.18,0l.1.06.12.09a.37.37,0,0,1,.07.14l.91,2.84a4.22,4.22,0,0,1,.12.46h0a3.31,3.31,0,0,1,0-.42v-2.27c0-.1.06-.11.18,0l.07,0a.29.29,0,0,1,.18.25v3.67c0,.1-.06.11-.18,0l-.09,0a.32.32,0,0,1-.17-.21l-.95-3a3.5,3.5,0,0,1-.11-.42h0a3.28,3.28,0,0,1,0,.4V134q0,.13-.18,0l-.07,0A.29.29,0,0,1,282.89,133.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.88,139.53v-3.68q0-.14.18,0l.1.06a.24.24,0,0,1,.11.09.26.26,0,0,1,.07.14l.92,2.84c0,.12.07.27.12.45h0a2.1,2.1,0,0,1,0-.41v-2.28c0-.09.07-.1.19,0l.06,0c.13.07.19.15.19.24v3.68c0,.1-.06.11-.19,0l-.08-.05a.37.37,0,0,1-.17-.21l-.95-2.95a2.51,2.51,0,0,1-.11-.42h0a3.15,3.15,0,0,1,0,.4v2.33c0,.1-.06.11-.19,0l-.06,0A.29.29,0,0,1,295.88,139.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.82,131.4a4.22,4.22,0,0,1-.28-1.67c0-1.34.36-1.8,1.07-1.39s1.07,1.29,1.07,2.62-.35,1.81-1.07,1.4A1.87,1.87,0,0,1,301.82,131.4Zm1.24.34a2.45,2.45,0,0,0,.15-1.05,3.84,3.84,0,0,0-.15-1.21,1,1,0,0,0-.44-.61c-.21-.12-.36-.09-.46.08A2.67,2.67,0,0,0,302,130a4,4,0,0,0,.15,1.22,1,1,0,0,0,.45.62C302.82,132,303,131.92,303.06,131.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,150.08a4.46,4.46,0,0,1-.27-1.67c0-1.33.37-1.79,1.08-1.37s1.07,1.29,1.06,2.62-.36,1.8-1.08,1.38A1.91,1.91,0,0,1,292,150.08Zm1.25.35a2.42,2.42,0,0,0,.15-1,3.61,3.61,0,0,0-.14-1.21,1.08,1.08,0,0,0-.45-.62c-.2-.12-.35-.09-.45.08a2.39,2.39,0,0,0-.15,1,3.67,3.67,0,0,0,.14,1.22,1.1,1.1,0,0,0,.45.63C293,150.64,293.13,150.61,293.23,150.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.14,116.86a4.4,4.4,0,0,1-.27-1.68,2.3,2.3,0,0,1,.27-1.35c.19-.23.47-.23.84,0a1.07,1.07,0,0,1,.22.15,1.11,1.11,0,0,1,.19.18.19.19,0,0,1,.07.11.25.25,0,0,1,0,.13.64.64,0,0,1,0,.24c0,.07-.06.08-.11,0a1.12,1.12,0,0,0-.34-.29c-.22-.13-.38-.11-.49.07a2.31,2.31,0,0,0-.16,1,4,4,0,0,0,.16,1.21,1.13,1.13,0,0,0,.49.64.59.59,0,0,0,.37.1h0c.05,0,.08.08.1.17a.75.75,0,0,1,0,.26c0,.09,0,.13-.11.13l-.19,0a.91.91,0,0,1-.25-.11A2,2,0,0,1,290.14,116.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.92,118.2v-3.67c0-.1.06-.11.18,0l.1.06a.28.28,0,0,1,.18.24v1.53l1,.58v-1.53c0-.1.06-.11.18,0l.09,0c.13.08.19.16.19.25v3.68c0,.09-.06.11-.19,0l-.09,0q-.18-.11-.18-.24v-1.63l-1-.58v1.63c0,.09-.06.11-.18,0l-.1-.06A.29.29,0,0,1,291.92,118.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.44,121.66a.94.94,0,0,1-.17-.18.25.25,0,0,1-.07-.15.12.12,0,0,1,0-.09s0,0,.06,0l.05.06a.87.87,0,0,0,.12.14l.14.11a.25.25,0,0,0,.22,0q.09,0,.09-.27a.63.63,0,0,0-.09-.35.56.56,0,0,0-.24-.24l-.1,0a.09.09,0,0,1,0-.06.22.22,0,0,1,0-.09v0s0-.07,0-.08,0,0,0,0l.08,0a.19.19,0,0,0,.17,0,.13.13,0,0,0,.09-.09.41.41,0,0,0,0-.16.61.61,0,0,0-.06-.25.39.39,0,0,0-.19-.19.28.28,0,0,0-.12,0,.14.14,0,0,0-.09,0h0s0-.05-.06-.11a.33.33,0,0,1,0-.14c0-.06.05-.08.13-.07a1,1,0,0,1,.27.1,1,1,0,0,1,.34.35.92.92,0,0,1,.13.49.37.37,0,0,1-.07.26.2.2,0,0,1-.18.07v0a.91.91,0,0,1,.22.33,1.12,1.12,0,0,1,.08.45.75.75,0,0,1-.06.33.22.22,0,0,1-.19.12.38.38,0,0,1-.26-.07A1.07,1.07,0,0,1,294.44,121.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.08,148.28a4.33,4.33,0,0,1-.26-1.67,2.3,2.3,0,0,1,.27-1.35c.18-.23.46-.23.84,0l.22.15.19.18a.26.26,0,0,1,.07.11.44.44,0,0,1,0,.13,1,1,0,0,1-.05.24c0,.07-.06.08-.11,0a1,1,0,0,0-.33-.29c-.22-.13-.39-.11-.49.07a2.17,2.17,0,0,0-.16,1,3.69,3.69,0,0,0,.16,1.21,1.09,1.09,0,0,0,.49.64.51.51,0,0,0,.36.09h0a.37.37,0,0,1,.1.18,1.09,1.09,0,0,1,0,.26c0,.09,0,.13-.11.13l-.19,0a1.74,1.74,0,0,1-.25-.11A2,2,0,0,1,303.08,148.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.86,149.63V146c0-.09.06-.1.19,0l.09.06a.28.28,0,0,1,.18.24v1.53l1,.58V146.8c0-.1.06-.11.19,0l.09.05c.12.08.18.16.18.25v3.68c0,.09-.06.11-.18,0l-.09-.05c-.13-.07-.19-.15-.19-.24v-1.63l-1-.58v1.63c0,.09-.06.1-.18,0l-.09-.06C304.92,149.81,304.86,149.73,304.86,149.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.38,153.09a1.41,1.41,0,0,1-.17-.18.33.33,0,0,1-.07-.15.18.18,0,0,1,0-.09s0,0,.06,0l.06.06.12.14.13.1a.23.23,0,0,0,.22,0q.09,0,.09-.27a.72.72,0,0,0-.08-.35.64.64,0,0,0-.25-.24l-.09,0a.1.1,0,0,1-.05-.06.22.22,0,0,1,0-.09v-.05s0-.07,0-.08a0,0,0,0,1,.05,0l.08,0a.2.2,0,0,0,.16,0,.13.13,0,0,0,.1-.09.41.41,0,0,0,0-.16.61.61,0,0,0-.06-.25.44.44,0,0,0-.19-.19.27.27,0,0,0-.13,0,.14.14,0,0,0-.09,0h0s0-.05-.06-.11a.5.5,0,0,1,0-.14q0-.09.12-.06a.72.72,0,0,1,.27.09.88.88,0,0,1,.34.35.92.92,0,0,1,.13.49.37.37,0,0,1-.07.26.18.18,0,0,1-.17.07h0a1.23,1.23,0,0,1,.21.34,1.13,1.13,0,0,1,.09.45.62.62,0,0,1-.07.33.21.21,0,0,1-.19.12.41.41,0,0,1-.26-.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.41,138.58V134.9c0-.1.07-.11.19,0l.1.06a.3.3,0,0,1,.17.24v1.53l1,.58v-1.53c0-.09.07-.1.19,0l.09,0a.29.29,0,0,1,.18.25v3.67c0,.1-.06.11-.18,0l-.09-.05a.32.32,0,0,1-.19-.25v-1.63l-1-.57v1.62c0,.1-.06.11-.17,0l-.1-.06C276.48,138.75,276.41,138.67,276.41,138.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.94,142l-.18-.18a.24.24,0,0,1-.06-.14.19.19,0,0,1,0-.1s0,0,.06,0l.06.06a.77.77,0,0,0,.12.13.53.53,0,0,0,.14.11.2.2,0,0,0,.21,0q.09,0,.09-.27a.65.65,0,0,0-.08-.35.76.76,0,0,0-.24-.23L279,141a.07.07,0,0,1,0-.05.3.3,0,0,1,0-.1v0a.13.13,0,0,1,0-.08s0,0,0,0l.08,0a.22.22,0,0,0,.16,0,.17.17,0,0,0,.1-.1.41.41,0,0,0,0-.16.53.53,0,0,0-.06-.24.46.46,0,0,0-.19-.2.28.28,0,0,0-.12,0h-.15l-.06-.11a.5.5,0,0,1,0-.14c0-.05,0-.07.13-.06a.61.61,0,0,1,.26.1.91.91,0,0,1,.35.35,1,1,0,0,1,.12.49.42.42,0,0,1-.06.25.25.25,0,0,1-.18.08h0a1,1,0,0,1,.21.33,1.13,1.13,0,0,1,.09.45.6.6,0,0,1-.07.33.22.22,0,0,1-.18.13.51.51,0,0,1-.27-.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.24,140.46a4.4,4.4,0,0,1-.27-1.68,2.35,2.35,0,0,1,.27-1.35c.19-.22.46-.22.84,0l.22.16a1.66,1.66,0,0,1,.19.18.2.2,0,0,1,.07.1.51.51,0,0,1,0,.13,1,1,0,0,1,0,.25c0,.07-.07.08-.11,0a1.33,1.33,0,0,0-.34-.3c-.22-.13-.39-.1-.49.08a2.12,2.12,0,0,0-.16,1,3.59,3.59,0,0,0,.16,1.2,1.12,1.12,0,0,0,.49.65.51.51,0,0,0,.36.09h0a.27.27,0,0,1,.1.17,1.27,1.27,0,0,1,0,.26c0,.09,0,.14-.11.14l-.2,0a1.74,1.74,0,0,1-.25-.11A1.91,1.91,0,0,1,280.24,140.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.7,139.14l0,0-4.15-5.59a.43.43,0,0,1-.09-.2v-6.38s0,0,0,0l2-.39s.12.07.18.17.08.18,0,.19l-2,.38v6.27l4,5.33,2.57-.49s.12.06.18.16.08.19,0,.2l-2.63.5S292.74,139.19,292.7,139.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.84,136.2a.5.5,0,0,1-.13-.25V131.8l-1.93-2.61c-.07-.09-.11-.2-.09-.23s.09,0,.16.1l2,2.73a.43.43,0,0,1,.09.2v4.24C297,136.29,296.91,136.28,296.84,136.2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.48,123.85a.49.49,0,0,1-.13-.26v-4.25c0-.06.06,0,.13,0a.47.47,0,0,1,.13.25v4.25C292.61,123.94,292.55,123.92,292.48,123.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.14,131.38a.36.36,0,0,1-.07-.1c-.06-.1-.08-.19,0-.2l3.76-1s.11.06.18.16.07.19,0,.2l-3.75,1S297.18,131.42,297.14,131.38Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.55,132.49a.31.31,0,0,1-.07-.09c-.06-.1-.08-.19,0-.2l3.75-1s.12.06.19.16.07.19,0,.2l-3.75,1S297.59,132.54,297.55,132.49Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,145.46l0,0-3.29-4.35c-.07-.09-.11-.2-.09-.24s.09,0,.16.1l3.29,4.34c.07.1.11.2.09.24S302,145.52,302,145.46Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.4,145.88a.5.5,0,0,1-.13-.25V139.7c0-.06.06,0,.13,0a.47.47,0,0,1,.13.25v5.93C292.53,146,292.47,146,292.4,145.88Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,146.23a.5.5,0,0,1-.13-.25v-5.93c0-.06.06-.05.13,0a.41.41,0,0,1,.13.25v5.93C293.17,146.32,293.12,146.31,293,146.23Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.56,124a.43.43,0,0,1-.13-.25c0-.06.05,0,.13,0l3,3.18h0a.43.43,0,0,1,.13.25c0,.06-.05.05-.13,0l-3-3.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.64,133.58a.62.62,0,0,1-.09-.12c-.05-.1-.06-.18,0-.18h2.92c.05,0,.13.08.18.18s.07.18,0,.18h-2.91A.14.14,0,0,1,285.64,133.58Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.33,130.82a.91.91,0,0,1-.11-.16L280.17,126c0-.06,0-.11,0-.13l1.82-2.53s.1,0,.17.1.1.2.08.24l-1.8,2.5,2,4.57c0,.1,0,.16,0,.13A.21.21,0,0,1,282.33,130.82Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,126.82l0,0c-.07-.09-.1-.2-.08-.23l1.53-2.13s.1,0,.16.11.11.2.08.23l-1.52,2.13S281.05,126.88,281,126.82Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.29,136l-.05-.08c-.07-.09-.09-.19-.06-.21l2.86-2s.11,0,.17.13.09.2.06.22l-2.86,2S279.34,136.08,279.29,136Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.75,140.44l-19-11a1.4,1.4,0,0,1-.71-1c0-.31.32-.39.71-.17l19,11a1.38,1.38,0,0,1,.7,1C333.45,140.58,333.14,140.66,332.75,140.44Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.75,143.44l-19-11a1.4,1.4,0,0,1-.71-1c0-.31.32-.39.71-.16l19,10.95a1.38,1.38,0,0,1,.7,1C333.45,143.59,333.14,143.66,332.75,143.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.75,149.67l-19-11a1.36,1.36,0,0,1-.71-1c0-.32.32-.4.71-.17l19,10.95a1.38,1.38,0,0,1,.7,1C333.45,149.82,333.14,149.89,332.75,149.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.75,152.67l-19-11a1.36,1.36,0,0,1-.71-1c0-.32.32-.4.71-.17l19,11a1.35,1.35,0,0,1,.7,1C333.45,152.82,333.14,152.89,332.75,152.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.75,161.9l-19-11a1.4,1.4,0,0,1-.71-1c0-.32.32-.39.71-.17l19,11a1.35,1.35,0,0,1,.7,1C333.45,162.05,333.14,162.13,332.75,161.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.75,158.9l-19-11a1.4,1.4,0,0,1-.71-1c0-.32.32-.39.71-.17l19,11a1.35,1.35,0,0,1,.7,1C333.45,159.05,333.14,159.13,332.75,158.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.75,171.72l-19-11a1.36,1.36,0,0,1-.71-1c0-.32.32-.4.71-.17l19,10.95a1.38,1.38,0,0,1,.7,1C333.45,171.87,333.14,171.94,332.75,171.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.75,168.72l-19-11a1.36,1.36,0,0,1-.71-1c0-.32.32-.4.71-.17l19,10.95a1.38,1.38,0,0,1,.7,1C333.45,168.87,333.14,168.94,332.75,168.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flasks--inject-103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--flasks--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-103",
    d: "M428,253.83l-39.39-22.75a.41.41,0,0,1,0-.77l23.85-13.77a1.5,1.5,0,0,1,1.34,0l39.38,22.75a.41.41,0,0,1,0,.78l-23.84,13.76A1.44,1.44,0,0,1,428,253.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.42 244.82 428.42 251.85 424.54 249.62 422.32 241.3 428.42 244.82",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.42 244.82 428.42 251.85 432.3 249.62 434.51 241.3 428.42 244.82",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.88 226.6 396.88 233.64 393 231.4 390.79 223.08 396.88 226.6",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.88 226.6 396.88 233.64 400.76 231.4 402.98 223.08 396.88 226.6",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.09 234.61 446.09 241.65 442.21 239.41 440 231.1 446.09 234.61",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.09 234.61 446.09 241.65 449.97 239.41 452.19 231.1 446.09 234.61",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.14,230.38l-38.11-22a1.48,1.48,0,0,0-1.3,0l-23.07,13.32a1.44,1.44,0,0,0-.65,1.13v.8a1.42,1.42,0,0,0,.65,1.12l38.11,22a1.48,1.48,0,0,0,1.3,0l23.07-13.32a1.46,1.46,0,0,0,.65-1.13v-.8A1.45,1.45,0,0,0,452.14,230.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.77,244.44l-38.11-22a.4.4,0,0,1,0-.75l23.07-13.32a1.48,1.48,0,0,1,1.3,0l38.11,22a.4.4,0,0,1,0,.75l-23.07,13.31A1.42,1.42,0,0,1,427.77,244.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.84,230c5,2.7,13,2.7,17.91,0s4.95-7.09,0-9.8-13-2.7-17.91,0S404.89,227.25,409.84,230Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--round-bottomed-flask--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.17,205.66a13.83,13.83,0,0,0-12.79,0c-3.53,2.08-3.53,5.46,0,7.54a13.83,13.83,0,0,0,12.79,0C428.7,211.12,428.7,207.74,425.17,205.66Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.17,205.66a13.83,13.83,0,0,0-12.79,0c-3.53,2.08-3.53,5.46,0,7.54a13.83,13.83,0,0,0,12.79,0C428.7,211.12,428.7,207.74,425.17,205.66Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M414.83,185.7V172.79l7.89,0V185.7a13.94,13.94,0,1,1-7.89,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.83,185.7V172.79l7.89,0V185.7a13.94,13.94,0,1,1-7.89,0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.77,213.61a14.29,14.29,0,0,1-3.94-27.91V172.79h2.22v14.87a13.1,13.1,0,0,0-7.9,7.09c-.95,2-1.38,6.43-.18,10.25A13.15,13.15,0,0,0,418.77,213.61Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.6 185.81 415.34 173.83 415.91 174.01 415.91 185.81 415.6 185.81",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.48,199.37a12.29,12.29,0,1,0,24.58,0,12.7,12.7,0,0,0-1-5,7,7,0,0,0-3.07-3.22c-4.54-2.68-11.89-2.68-16.43,0a7,7,0,0,0-3.07,3.22A12.71,12.71,0,0,0,406.48,199.37Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.48,199.37a12.29,12.29,0,1,0,24.58,0,12.7,12.7,0,0,0-1-5,7,7,0,0,0-3.07-3.22c-4.54-2.68-11.89-2.68-16.43,0a7,7,0,0,0-3.07,3.22A12.71,12.71,0,0,0,406.48,199.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.48,199.37a12.76,12.76,0,0,1,1-4.93l3.83,6.82c0,4.58,3.22,10.68,7.48,10.68A12.44,12.44,0,0,1,406.48,199.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.56,200.86c4.54,2.68,11.89,2.68,16.43,0,3-1.76,4-4.23,3.07-6.48a7,7,0,0,0-3.07-3.22c-4.54-2.68-11.89-2.68-16.43,0a7,7,0,0,0-3.07,3.22C406.56,196.63,407.58,199.1,410.56,200.86Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.09,201.15a15.49,15.49,0,0,0,4.3.12c.54-.06,1.19-.27,1.28-.8,0-1.36,2.11-1.39,3-1.48a3.86,3.86,0,0,0,1.36-.31,1.27,1.27,0,0,0,.74-1.11,2.57,2.57,0,0,0-.49-1.08,1.07,1.07,0,0,1-.14-1.12,1.17,1.17,0,0,1,.56-.41,24.36,24.36,0,0,1,4-.88,1.46,1.46,0,0,0,1-.68,1.33,1.33,0,0,0,0-.86,4.36,4.36,0,0,0-1.67-2.19l-.39-.26a13.15,13.15,0,0,1,2.34,1.07,7,7,0,0,1,3.07,3.22c.93,2.25-.09,4.72-3.07,6.48C422.63,203.44,415.66,203.53,411.09,201.15Z",
    style: {
      fill: "#fff",
      mixBlendMode: "hard-light",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.49,196.27a.54.54,0,0,1-.33-.08c-.63-.53,1.29-1,1.68-.86s.46.58,0,.77A3.08,3.08,0,0,1,422.49,196.27Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,199.08a.76.76,0,0,1,.42.23.18.18,0,0,1,.06.17.47.47,0,0,1-.06.09.87.87,0,0,1-.53.2,1.4,1.4,0,0,1-.57-.1.81.81,0,0,1-.18-.1.22.22,0,0,1-.07-.18.28.28,0,0,1,.11-.17A1.17,1.17,0,0,1,416,199.08Z",
    style: {
      fill: "#fff",
      mixBlendMode: "hard-light",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.86,187.56V173.64a10,10,0,0,0,2.66-.34v13.06a13.1,13.1,0,0,1,10.36,12.75c0,7-4.42,13.54-13.11,13.54C430.52,208.71,430.83,192.05,418.86,187.56Z",
    style: {
      fill: "#fff",
      mixBlendMode: "hard-light",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.83,175.49v-2.7l7.89,0v2.68a4.85,4.85,0,0,1-.5.34,7.43,7.43,0,0,1-6.89,0A4.85,4.85,0,0,1,414.83,175.49Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.88,171.31a2.1,2.1,0,0,0-1.2-1.72,6.34,6.34,0,0,0-5.81,0,2.1,2.1,0,0,0-1.2,1.72h0v1.81h0a2.1,2.1,0,0,0,1.2,1.72,6.34,6.34,0,0,0,5.81,0,2.1,2.1,0,0,0,1.2-1.72h0v-1.81Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.88,171.31a2.1,2.1,0,0,0-1.2-1.72,6.34,6.34,0,0,0-5.81,0,2.1,2.1,0,0,0-1.2,1.72h0v1.81h0a2.1,2.1,0,0,0,1.2,1.72,6.34,6.34,0,0,0,5.81,0,2.1,2.1,0,0,0,1.2-1.72h0v-1.81Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,174.66a6.93,6.93,0,0,1-4.65.34c-1.27-.55-1.9-1.1-1.9-2.35v-2.72a1.84,1.84,0,0,0-.73,1.38h0v1.81h0a2.1,2.1,0,0,0,1.2,1.72,6.34,6.34,0,0,0,5.81,0Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.87,173a6.28,6.28,0,0,0,5.81,0c1.6-.94,1.6-2.48,0-3.43a6.34,6.34,0,0,0-5.81,0C414.27,170.54,414.27,172.08,415.87,173Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.87,173a6.28,6.28,0,0,0,5.81,0c1.6-.94,1.6-2.48,0-3.43a6.34,6.34,0,0,0-5.81,0C414.27,170.54,414.27,172.08,415.87,173Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.63,169.72c-1.56.39-2.08,1.51-1.39,2.38s2,1.58,4.3,1.29,2.82-1.47,2.82-1.75Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.24,172.69a5.87,5.87,0,0,0,5.11,0c1.41-.77,1.41-2,0-2.79a5.94,5.94,0,0,0-5.11,0C414.83,170.67,414.83,171.92,416.24,172.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.24,172.69a5.87,5.87,0,0,0,5.11,0c1.41-.77,1.41-2,0-2.79a5.94,5.94,0,0,0-5.11,0C414.83,170.67,414.83,171.92,416.24,172.69Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.29,171.92a4.17,4.17,0,0,1,1.06.4,2.2,2.2,0,0,1,.3.19c1.1-.78,1-1.9-.3-2.61a5.44,5.44,0,0,0-2.4-.57C420.92,169.57,421.2,171.12,420.29,171.92Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.24,172.32l-.3.19a3,3,0,0,0,.3.18,5.87,5.87,0,0,0,5.11,0,2.16,2.16,0,0,0,.3-.18,2.2,2.2,0,0,0-.3-.19A5.94,5.94,0,0,0,416.24,172.32Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.48,200.86a.7.7,0,0,0-.09.86.75.75,0,0,0,.79.37.71.71,0,0,1-1-.27A.71.71,0,0,1,428.48,200.86Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.83,200.81a.67.67,0,0,1,.58.34.72.72,0,0,1,.06.5.64.64,0,0,1-.32.4.62.62,0,0,1-.32.09.67.67,0,0,1-.58-.34.62.62,0,0,1-.06-.5.66.66,0,0,1,.31-.4.63.63,0,0,1,.33-.09m0,0a.73.73,0,0,0-.35.09.71.71,0,0,0,.35,1.32.73.73,0,0,0,.35-.09.71.71,0,0,0-.35-1.32Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M429,201a.54.54,0,0,1,.37.61s-.07.08-.11,0-.09-.12-.15-.17a.72.72,0,0,0-.19-.11c-.15,0-.24,0-.3-.16S428.71,200.86,429,201Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.68,201.08a.11.11,0,0,0,.09.13.11.11,0,0,0,0-.21A.11.11,0,0,0,428.68,201.08Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.46,208.29a1,1,0,0,0-.14,1.21,1.08,1.08,0,0,0,1.12.54,1,1,0,0,1-1-1.75Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419,208.22a.93.93,0,0,1,.82.48,1,1,0,0,1,.09.72.94.94,0,1,1-.91-1.2m0-.06a1,1,0,0,0-.49.13,1,1,0,0,0,.49,1.88,1,1,0,0,0,.49-.13,1,1,0,0,0-.49-1.88Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M419.19,208.45a.77.77,0,0,1,.53.87c0,.05-.11.12-.16.07a2.52,2.52,0,0,0-.21-.25.76.76,0,0,0-.26-.15c-.21-.05-.35-.05-.43-.24S418.78,208.28,419.19,208.45Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.74,208.61a.15.15,0,0,0,.12.17.15.15,0,1,0,.06-.29A.15.15,0,0,0,418.74,208.61Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,206.23a1,1,0,0,0-.08,1.22,1.08,1.08,0,0,0,1.14.49,1,1,0,0,1-1.06-1.71Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.52,206.14a1,1,0,0,1,.84.44.94.94,0,0,1-.3,1.3.82.82,0,0,1-.45.14.94.94,0,0,1-.54-1.74,1,1,0,0,1,.45-.14m0-.06a1.08,1.08,0,0,0-.49.15,1,1,0,0,0-.32,1.38,1,1,0,0,0,.9.48,1,1,0,0,0,.48-.15,1,1,0,0,0,.33-1.39,1,1,0,0,0-.9-.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M412.77,206.36a.76.76,0,0,1,.56.85s-.09.12-.15.07-.13-.17-.22-.24a.68.68,0,0,0-.27-.13c-.21,0-.35,0-.44-.22S412.36,206.21,412.77,206.36Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.33,206.54a.15.15,0,1,0,.17-.13A.15.15,0,0,0,412.33,206.54Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.82,205.57a.42.42,0,0,0-.06.52.47.47,0,0,0,.49.24.45.45,0,0,1-.6-.17A.44.44,0,0,1,416.82,205.57Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417,205.54a.41.41,0,0,1,.36.21.4.4,0,0,1-.16.55.35.35,0,0,1-.2,0,.41.41,0,0,1-.2-.76.46.46,0,0,1,.2-.05m0,0a.42.42,0,0,0-.21.06.43.43,0,0,0,.21.81.54.54,0,0,0,.22,0,.44.44,0,0,0,.16-.6.43.43,0,0,0-.38-.22Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M417.14,205.64a.32.32,0,0,1,.22.37s0,.06-.06,0a.48.48,0,0,1-.09-.11.45.45,0,0,0-.12-.06c-.09,0-.15,0-.18-.1S417,205.56,417.14,205.64Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.94,205.7s0,.08.06.08a.05.05,0,0,0,.07-.05.06.06,0,0,0-.05-.08A.08.08,0,0,0,416.94,205.7Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.16,204.07a.37.37,0,0,0,0,.46.4.4,0,0,0,.42.18.37.37,0,0,1-.39-.64Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.34,204a.36.36,0,0,1,.31.16.37.37,0,0,1-.11.49.36.36,0,0,1-.48-.11.37.37,0,0,1-.05-.27.36.36,0,0,1,.16-.22.34.34,0,0,1,.17-.05m0,0a.35.35,0,0,0-.18,0,.37.37,0,0,0-.12.52.35.35,0,0,0,.33.17.37.37,0,0,0,.3-.57.35.35,0,0,0-.33-.17Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413.43,204.12c.15.06.25.2.21.32a0,0,0,0,1-.06,0s0-.06-.08-.09a.31.31,0,0,0-.1-.05c-.08,0-.13,0-.16-.08S413.28,204.07,413.43,204.12Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.27,204.19a0,0,0,0,0,0,.06.07.07,0,0,0,.07-.05.06.06,0,0,0-.05-.06A.05.05,0,0,0,413.27,204.19Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.15,205.64a.89.89,0,0,0-.12,1.06.93.93,0,0,0,1,.46.86.86,0,0,1-1.18-.33A.87.87,0,0,1,426.15,205.64Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.58,205.59a.84.84,0,0,1,.71.41.82.82,0,0,1-.31,1.11.83.83,0,0,1-.4.11.83.83,0,0,1-.79-1,.83.83,0,0,1,.39-.49.79.79,0,0,1,.4-.1m0-.06a.92.92,0,0,0-.43.11.87.87,0,0,0,.43,1.63.8.8,0,0,0,.42-.11.87.87,0,0,0-.42-1.63Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.78,205.79a.67.67,0,0,1,.46.75c0,.05-.09.1-.14.06s-.1-.15-.18-.22a.65.65,0,0,0-.23-.13c-.18,0-.29,0-.37-.2S426.43,205.64,426.78,205.79Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.4,205.92a.13.13,0,1,0,.25.05.13.13,0,0,0-.25-.05Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.81,202.45a.73.73,0,0,0,.24.85.77.77,0,0,0,.88,0,.72.72,0,1,1-1.12-.9Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.37,202.23a.68.68,0,0,1,.42.14.71.71,0,0,1,.25.45.69.69,0,0,1-.14.5.67.67,0,0,1-.53.25.71.71,0,0,1-.42-.14.67.67,0,0,1-.1-1,.65.65,0,0,1,.52-.25m0,0a.74.74,0,0,0-.56.27.72.72,0,0,0,.56,1.17.71.71,0,0,0,.56-.27.72.72,0,0,0-.11-1,.69.69,0,0,0-.45-.16Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M409.34,202.37a.54.54,0,0,1,.58.43s0,.11-.08.09-.13-.09-.21-.11a.51.51,0,0,0-.21,0c-.16,0-.25.06-.35,0S409,202.36,409.34,202.37Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.08,202.59a.11.11,0,0,0,.22,0,.12.12,0,0,0-.13-.09A.11.11,0,0,0,409.08,202.59Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.84,203.34a.26.26,0,0,0,0,.32.3.3,0,0,0,.29.14.26.26,0,0,1-.25-.46Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426,203.32a.25.25,0,0,1,.22.13.22.22,0,0,1,0,.18.25.25,0,0,1-.11.15.27.27,0,0,1-.12,0,.26.26,0,0,1-.22-.12.26.26,0,0,1,.09-.34l.12,0m0,0a.28.28,0,0,0-.12,0,.26.26,0,0,0-.1.36.25.25,0,0,0,.23.13l.12,0a.27.27,0,0,0,.1-.36.24.24,0,0,0-.23-.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426,203.38a.2.2,0,0,1,.13.23,0,0,0,0,1,0,0l-.05-.07-.07,0c-.06,0-.09,0-.11-.06S425.92,203.34,426,203.38Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.91,203.42a0,0,0,0,0,.08,0s0-.05,0-.05S425.91,203.4,425.91,203.42Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.05,205.49a.26.26,0,0,0,0,.32.3.3,0,0,0,.29.14.26.26,0,0,1-.25-.46Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.18,205.47a.24.24,0,0,1,.21.13.22.22,0,0,1,0,.18.25.25,0,0,1-.11.15.27.27,0,0,1-.12,0,.27.27,0,0,1-.22-.12.26.26,0,0,1,.1-.34.21.21,0,0,1,.12,0m0,0a.28.28,0,0,0-.13,0,.26.26,0,0,0,.13.49.27.27,0,0,0,.12,0,.26.26,0,0,0,.1-.36.23.23,0,0,0-.22-.13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M422.24,205.53a.2.2,0,0,1,.13.23,0,0,0,0,1,0,0l-.05-.07-.07,0s-.09,0-.11-.06S422.13,205.49,422.24,205.53Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.12,205.57a0,0,0,1,0,.05,0A.05.05,0,0,0,422.12,205.57Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.53,200.31a.27.27,0,0,0,0,.32.29.29,0,0,0,.3.14.26.26,0,0,1-.36-.1A.27.27,0,0,1,407.53,200.31Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.66,200.3a.24.24,0,0,1,.21.12.25.25,0,0,1,0,.19.23.23,0,0,1-.11.15.27.27,0,0,1-.12,0,.26.26,0,0,1-.22-.13.25.25,0,0,1,.1-.33.24.24,0,0,1,.12,0m0,0a.28.28,0,0,0-.13,0,.27.27,0,0,0,.13.5.33.33,0,0,0,.13,0,.27.27,0,0,0,.1-.36.28.28,0,0,0-.23-.13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M407.72,200.36c.1,0,.17.14.14.22s0,0,0,0l-.06-.06a.1.1,0,0,0-.07,0c-.05,0-.09,0-.11-.06S407.61,200.31,407.72,200.36Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.6,200.4s0,0,0,0a0,0,0,0,0,.05,0s0,0,0,0S407.61,200.38,407.6,200.4Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--round-bottomed-flask--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.18,117.48a13.83,13.83,0,0,0-12.79,0c-3.53,2.08-3.53,5.46,0,7.55a13.89,13.89,0,0,0,12.79,0C397.71,122.94,397.71,119.56,394.18,117.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.18,117.48a13.83,13.83,0,0,0-12.79,0c-3.53,2.08-3.53,5.46,0,7.55a13.89,13.89,0,0,0,12.79,0C397.71,122.94,397.71,119.56,394.18,117.48Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M383.84,97.52V79.39l7.88,0V97.52a13.94,13.94,0,1,1-7.89,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.84,97.52V79.39l7.88,0V97.52a13.94,13.94,0,1,1-7.89,0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.79,125.44a14.29,14.29,0,0,1-4-27.92V79.39h2.21V99.49a13.09,13.09,0,0,0-7.9,7.1c-1,2-1.38,6.42-.18,10.25A13.17,13.17,0,0,0,387.79,125.44Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.61 97.64 384.35 80.43 384.92 80.61 384.92 97.64 384.61 97.64",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.49,111.19a12.3,12.3,0,1,0,24.59,0,12.74,12.74,0,0,0-1-5A7,7,0,0,0,396,103c-4.54-2.68-11.89-2.68-16.43,0a7,7,0,0,0-3.07,3.22A12.74,12.74,0,0,0,375.49,111.19Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.49,111.19a12.3,12.3,0,1,0,24.59,0,12.74,12.74,0,0,0-1-5A7,7,0,0,0,396,103c-4.54-2.68-11.89-2.68-16.43,0a7,7,0,0,0-3.07,3.22A12.74,12.74,0,0,0,375.49,111.19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.49,111.19a12.8,12.8,0,0,1,1-4.93c1,1.7,3.83,6.83,3.83,6.83,0,4.57,3.22,10.67,7.48,10.67A12.44,12.44,0,0,1,375.49,111.19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.57,112.68c4.54,2.68,11.89,2.68,16.43,0,3-1.75,4-4.23,3.07-6.48A7,7,0,0,0,396,103c-4.54-2.68-11.89-2.68-16.43,0a7,7,0,0,0-3.07,3.22C375.57,108.45,376.59,110.93,379.57,112.68Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.1,113a15.88,15.88,0,0,0,4.3.11c.54-.06,1.19-.26,1.28-.79,0-1.37,2.11-1.39,3-1.49a3.47,3.47,0,0,0,1.36-.31,1.26,1.26,0,0,0,.74-1.1,2.41,2.41,0,0,0-.49-1.08,1.11,1.11,0,0,1-.14-1.13,1.1,1.1,0,0,1,.56-.4,24.38,24.38,0,0,1,4-.89,1.46,1.46,0,0,0,1-.68,1.3,1.3,0,0,0,0-.85,4.34,4.34,0,0,0-1.67-2.2l-.39-.26A13.15,13.15,0,0,1,396,103a7,7,0,0,1,3.07,3.22c.93,2.25-.09,4.73-3.07,6.48C391.64,115.26,384.67,115.36,380.1,113Z",
    style: {
      fill: "#fff",
      mixBlendMode: "hard-light",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.5,108.09a.54.54,0,0,1-.33-.08c-.63-.52,1.29-1,1.68-.86s.46.58,0,.78A3.07,3.07,0,0,1,391.5,108.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,110.91a.75.75,0,0,1,.42.22.19.19,0,0,1,.06.17.2.2,0,0,1-.06.09.81.81,0,0,1-.53.2,1.33,1.33,0,0,1-.56-.1.4.4,0,0,1-.18-.1.18.18,0,0,1-.08-.18.32.32,0,0,1,.11-.17A1.12,1.12,0,0,1,385,110.91Z",
    style: {
      fill: "#fff",
      mixBlendMode: "hard-light",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.87,99.38V80.24a10,10,0,0,0,2.66-.34V98.19a13.08,13.08,0,0,1,10.36,12.75c0,7-4.42,13.53-13.1,13.53C399.53,120.53,399.84,103.87,387.87,99.38Z",
    style: {
      fill: "#fff",
      mixBlendMode: "hard-light",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.84,82.09v-2.7l7.88,0v2.68a4.85,4.85,0,0,1-.5.34,7.43,7.43,0,0,1-6.89,0A4.85,4.85,0,0,1,383.84,82.09Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.89,77.91a2.1,2.1,0,0,0-1.2-1.72,6.34,6.34,0,0,0-5.81,0,2.1,2.1,0,0,0-1.2,1.72h0v1.81h0a2.1,2.1,0,0,0,1.2,1.72,6.34,6.34,0,0,0,5.81,0,2.1,2.1,0,0,0,1.2-1.72h0V77.91Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.89,77.91a2.1,2.1,0,0,0-1.2-1.72,6.34,6.34,0,0,0-5.81,0,2.1,2.1,0,0,0-1.2,1.72h0v1.81h0a2.1,2.1,0,0,0,1.2,1.72,6.34,6.34,0,0,0,5.81,0,2.1,2.1,0,0,0,1.2-1.72h0V77.91Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,81.26a6.93,6.93,0,0,1-4.65.34c-1.27-.55-1.9-1.1-1.9-2.35V76.53a1.84,1.84,0,0,0-.73,1.38h0v1.81h0a2.1,2.1,0,0,0,1.2,1.72,6.34,6.34,0,0,0,5.81,0Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.88,79.62a6.28,6.28,0,0,0,5.81,0c1.6-.94,1.6-2.48,0-3.43a6.34,6.34,0,0,0-5.81,0C383.28,77.14,383.28,78.68,384.88,79.62Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.88,79.62a6.28,6.28,0,0,0,5.81,0c1.6-.94,1.6-2.48,0-3.43a6.34,6.34,0,0,0-5.81,0C383.28,77.14,383.28,78.68,384.88,79.62Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.64,76.32c-1.56.39-2.08,1.51-1.39,2.38s2,1.58,4.3,1.29,2.82-1.47,2.82-1.75Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25,79.3a5.94,5.94,0,0,0,5.11,0c1.41-.78,1.41-2,0-2.8a5.94,5.94,0,0,0-5.11,0C383.84,77.27,383.84,78.52,385.25,79.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25,79.3a5.94,5.94,0,0,0,5.11,0c1.41-.78,1.41-2,0-2.8a5.94,5.94,0,0,0-5.11,0C383.84,77.27,383.84,78.52,385.25,79.3Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.3,78.52a4.17,4.17,0,0,1,1.06.4,2.2,2.2,0,0,1,.3.19c1.1-.77,1-1.9-.3-2.61a5.41,5.41,0,0,0-2.4-.57C389.93,76.17,390.21,77.72,389.3,78.52Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25,78.92l-.3.19.3.19a5.94,5.94,0,0,0,5.11,0l.3-.19a2.2,2.2,0,0,0-.3-.19A5.94,5.94,0,0,0,385.25,78.92Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.49,112.68a.7.7,0,0,0-.09.86.76.76,0,0,0,.79.38.71.71,0,1,1-.7-1.24Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.84,112.64a.68.68,0,0,1,.58.33.75.75,0,0,1,.06.51.67.67,0,0,1-.32.4.72.72,0,0,1-.32.08.67.67,0,0,1-.58-.34.62.62,0,0,1-.06-.5.69.69,0,0,1,.31-.4.64.64,0,0,1,.33-.08m0,0a.73.73,0,0,0-.35.09.71.71,0,0,0,.35,1.33.73.73,0,0,0,.35-.09.72.72,0,0,0,.27-1,.71.71,0,0,0-.62-.36Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M398,112.8a.54.54,0,0,1,.37.61s-.07.08-.11,0-.09-.13-.15-.18a.44.44,0,0,0-.19-.1c-.15,0-.24,0-.3-.17S397.72,112.68,398,112.8Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.69,112.91a.11.11,0,0,0,.21,0,.11.11,0,0,0-.08-.13A.11.11,0,0,0,397.69,112.91Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.47,120.11a1,1,0,0,0-.14,1.22,1.07,1.07,0,0,0,1.12.53,1,1,0,0,1-1-1.75Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388,120a1,1,0,0,1,.82.48.91.91,0,0,1,.09.72,1,1,0,0,1-.45.57,1,1,0,0,1-.46.12.94.94,0,0,1-.9-1.2.88.88,0,0,1,.44-.56A.94.94,0,0,1,388,120m0-.06a1,1,0,0,0-.49.13,1,1,0,0,0-.38,1.37,1,1,0,0,0,.87.51,1,1,0,0,0,.49-.13A1,1,0,0,0,388,120Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.2,120.28a.76.76,0,0,1,.53.86c0,.06-.11.12-.16.07s-.12-.18-.21-.25a.76.76,0,0,0-.26-.15c-.21,0-.35,0-.43-.23S387.79,120.11,388.2,120.28Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.75,120.43a.16.16,0,0,0,.12.18.15.15,0,0,0,.18-.12.15.15,0,0,0-.12-.18A.16.16,0,0,0,387.75,120.43Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,118.05a1,1,0,0,0-.08,1.23,1.08,1.08,0,0,0,1.15.48,1,1,0,0,1-1.07-1.71Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.53,118a.94.94,0,0,1,.09,1.88.94.94,0,0,1-.84-.45.93.93,0,0,1,.3-1.29.8.8,0,0,1,.45-.14m0-.07a1.08,1.08,0,0,0-.49.15,1,1,0,0,0-.32,1.39,1,1,0,0,0,.9.47,1.12,1.12,0,0,0,.49-.15,1,1,0,0,0,.32-1.39,1,1,0,0,0-.9-.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M381.78,118.19a.75.75,0,0,1,.56.84s-.09.12-.15.07-.13-.17-.22-.24a.84.84,0,0,0-.27-.13c-.21,0-.35,0-.44-.22S381.37,118,381.78,118.19Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.34,118.36a.16.16,0,0,0,.13.17.15.15,0,0,0,0-.3A.16.16,0,0,0,381.34,118.36Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.83,117.39a.44.44,0,0,0-.06.53.47.47,0,0,0,.49.23.44.44,0,1,1-.43-.76Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386,117.36a.41.41,0,0,1,.2.77.46.46,0,0,1-.2.05.4.4,0,0,1-.35-.21.42.42,0,0,1,.15-.56.46.46,0,0,1,.2,0m0,0a.42.42,0,0,0-.21.06.44.44,0,0,0-.17.59.43.43,0,1,0,.76-.42.42.42,0,0,0-.38-.23Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.15,117.46a.34.34,0,0,1,.23.38s-.05,0-.07,0-.05-.08-.09-.11a.2.2,0,0,0-.12-.06c-.09,0-.15,0-.18-.11S386,117.39,386.15,117.46Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,117.53a.08.08,0,0,0,.06.08.07.07,0,0,0,.07-.06.05.05,0,0,0-.05-.07A.06.06,0,0,0,386,117.53Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.17,115.9a.37.37,0,0,0,0,.45.39.39,0,0,0,.42.18.37.37,0,1,1-.39-.63Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.35,115.86a.37.37,0,0,1,.31.17.35.35,0,0,1-.11.48.34.34,0,0,1-.17,0,.32.32,0,0,1-.31-.16.36.36,0,0,1-.05-.27.34.34,0,0,1,.16-.21.35.35,0,0,1,.17-.06m0,0a.28.28,0,0,0-.18.06.36.36,0,0,0-.12.51.38.38,0,0,0,.33.18.39.39,0,0,0,.18-.06.36.36,0,0,0,.12-.51.36.36,0,0,0-.33-.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M382.44,116a.27.27,0,0,1,.21.31,0,0,0,0,1-.06,0s0-.07-.08-.09a.19.19,0,0,0-.1,0c-.08,0-.13,0-.16-.08S382.29,115.89,382.44,116Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.28,116a0,0,0,0,0,.05.06s.05,0,.06,0a.08.08,0,0,0-.05-.07A.06.06,0,0,0,382.28,116Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.16,117.47a.87.87,0,0,0-.12,1,.94.94,0,0,0,1,.47.87.87,0,0,1-1.18-.34A.86.86,0,0,1,395.16,117.47Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.59,117.41a.82.82,0,1,1,0,1.63.81.81,0,0,1-.71-.41.8.8,0,0,1,.31-1.11.8.8,0,0,1,.4-.11m0,0a.81.81,0,0,0-.43.11.87.87,0,0,0,.43,1.63A.91.91,0,0,0,396,119a.87.87,0,0,0-.42-1.63Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M395.79,117.61a.67.67,0,0,1,.46.75s-.09.11-.14.06-.1-.15-.18-.22a.63.63,0,0,0-.23-.12c-.18,0-.29,0-.37-.21S395.44,117.46,395.79,117.61Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.41,117.74a.13.13,0,1,0,.25.05.12.12,0,0,0-.1-.15A.13.13,0,0,0,395.41,117.74Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.82,114.28a.72.72,0,0,0,.24.84.76.76,0,0,0,.88,0,.72.72,0,1,1-1.12-.89Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.38,114.05a.64.64,0,0,1,.42.15.67.67,0,0,1,.11.94.67.67,0,1,1-1.05-.83.64.64,0,0,1,.52-.26m0,0a.72.72,0,0,0-.44,1.28.73.73,0,0,0,.44.15.71.71,0,0,0,.56-.27.72.72,0,0,0-.11-1,.74.74,0,0,0-.45-.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M378.35,114.19a.54.54,0,0,1,.58.43s0,.11-.08.09-.13-.08-.21-.11a.76.76,0,0,0-.21,0c-.16,0-.25.06-.35,0S378,114.19,378.35,114.19Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.09,114.41a.12.12,0,0,0,.13.09.11.11,0,0,0,.09-.13.1.1,0,0,0-.13-.08A.1.1,0,0,0,378.09,114.41Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.85,115.16a.26.26,0,0,0,0,.32.28.28,0,0,0,.29.14.25.25,0,0,1-.35-.1A.26.26,0,0,1,394.85,115.16Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395,115.15a.24.24,0,0,1,.21.12.25.25,0,0,1,0,.19.26.26,0,0,1-.11.14.19.19,0,0,1-.12,0,.25.25,0,0,1-.22-.13.24.24,0,0,1,.09-.33.28.28,0,0,1,.13,0m0,0a.28.28,0,0,0-.13,0,.26.26,0,0,0-.1.36.25.25,0,0,0,.23.13l.12,0a.26.26,0,0,0,.1-.36.25.25,0,0,0-.22-.13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M395,115.21a.19.19,0,0,1,.13.22s0,0,0,0l-.05-.07-.07,0c-.05,0-.09,0-.11-.07S394.93,115.16,395,115.21Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.92,115.25s0,0,0,0,0,0,.05,0a.05.05,0,0,0,0-.05A.05.05,0,0,0,394.92,115.25Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.06,117.31a.26.26,0,0,0,0,.32.28.28,0,0,0,.29.14.25.25,0,0,1-.35-.1A.26.26,0,0,1,391.06,117.31Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.19,117.3a.24.24,0,0,1,.21.12.25.25,0,0,1,0,.19.26.26,0,0,1-.11.14.19.19,0,0,1-.12,0,.26.26,0,0,1-.22-.13.24.24,0,0,1,.1-.33.21.21,0,0,1,.12,0m0,0a.28.28,0,0,0-.13,0,.26.26,0,0,0-.1.36.25.25,0,0,0,.23.13.27.27,0,0,0,.12,0,.25.25,0,0,0,.1-.36.25.25,0,0,0-.22-.13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M391.25,117.36a.21.21,0,0,1,.14.22,0,0,0,0,1-.05,0l0-.07-.07,0c-.05,0-.09,0-.11-.07S391.14,117.31,391.25,117.36Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.13,117.4s0,0,0,0,0,0,0,0a.05.05,0,0,0,0,0A.05.05,0,0,0,391.13,117.4Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.54,112.14a.26.26,0,0,0,0,.32.3.3,0,0,0,.3.14.27.27,0,0,1-.36-.1A.26.26,0,0,1,376.54,112.14Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.67,112.12a.23.23,0,0,1,.21.13.22.22,0,0,1,0,.18.19.19,0,0,1-.11.15l-.12,0a.27.27,0,0,1-.22-.12.26.26,0,0,1,.1-.34.24.24,0,0,1,.12,0m0,0a.28.28,0,0,0-.13,0,.26.26,0,0,0-.1.36.28.28,0,0,0,.23.13.31.31,0,0,0,.13,0,.28.28,0,0,0,.1-.36.27.27,0,0,0-.23-.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M376.73,112.18a.2.2,0,0,1,.14.23s0,0,0,0,0-.05-.06-.07l-.07,0c-.05,0-.09,0-.11-.06S376.62,112.14,376.73,112.18Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.61,112.22a.05.05,0,0,0,0,0s0,0,0,0a0,0,0,0,0,0,0A.05.05,0,0,0,376.61,112.22Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M422.71,176.2v1.25a.11.11,0,0,1,0,.08,1.84,1.84,0,0,1-1.14,1.48,6.52,6.52,0,0,1-5.59,0,1.94,1.94,0,0,1-1.15-1.38,1.31,1.31,0,0,1,0-.28v-1.1h0a2.22,2.22,0,0,0-.43.73,1.8,1.8,0,0,0-.08.5v2a1.86,1.86,0,0,0,.52,1.25,3.24,3.24,0,0,0,.79.62,6.85,6.85,0,0,0,6.35,0,3.24,3.24,0,0,0,.75-.58,1.85,1.85,0,0,0,.57-1.29v-2A1.85,1.85,0,0,0,422.71,176.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.13,181l14.31,8.24,1-1.7-14.3-8.24h0a.49.49,0,0,0-.49.05,1.54,1.54,0,0,0-.69,1.2A.5.5,0,0,0,422.13,181Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.71,176.2v1.25a.11.11,0,0,1,0,.08,1.84,1.84,0,0,1-1.14,1.48,6.52,6.52,0,0,1-5.59,0,1.94,1.94,0,0,1-1.15-1.38,1.31,1.31,0,0,1,0-.28v-1.1h0a2,2,0,0,0-.43.73,1.78,1.78,0,0,0-.08.45v.14a1.84,1.84,0,0,0,.52,1.17,3.45,3.45,0,0,0,.79.62,6.91,6.91,0,0,0,6.35,0,3.24,3.24,0,0,0,.75-.58,1.89,1.89,0,0,0,.57-1.3A1.85,1.85,0,0,0,422.71,176.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.73,86.79v1.32a1.89,1.89,0,0,1-1.15,1.49,6.52,6.52,0,0,1-5.59,0,2,2,0,0,1-1.15-1.39,1.31,1.31,0,0,1,0-.28V86.85a2.26,2.26,0,0,0-.43.72,1.81,1.81,0,0,0-.08.51v2a1.86,1.86,0,0,0,.52,1.25,3.71,3.71,0,0,0,.79.63,6.91,6.91,0,0,0,6.35,0,3.32,3.32,0,0,0,.75-.59,1.85,1.85,0,0,0,.57-1.29v-2A1.87,1.87,0,0,0,391.73,86.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.73,86.79v1.32a1.89,1.89,0,0,1-1.15,1.49,6.52,6.52,0,0,1-5.59,0,2,2,0,0,1-1.15-1.39,1.31,1.31,0,0,1,0-.28V86.85a1.92,1.92,0,0,0-.43.72,1.78,1.78,0,0,0-.08.45v.14a1.88,1.88,0,0,0,.52,1.17,3.15,3.15,0,0,0,.79.62A6.91,6.91,0,0,0,391,90a3,3,0,0,0,.75-.58,1.74,1.74,0,0,0,0-2.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.9,186.86V112.64h-2V235.29h0a.49.49,0,0,0,.29.4,1.55,1.55,0,0,0,1.39,0,.49.49,0,0,0,.28-.4V186.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.76,186.35a2.16,2.16,0,0,0-.91,2,6.86,6.86,0,0,0,3.1,5.37,2.19,2.19,0,0,0,2.2.22l2-1.14a2.19,2.19,0,0,0,.91-2,6.86,6.86,0,0,0-3.1-5.37,2.2,2.2,0,0,0-2.19-.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,193.72a1.89,1.89,0,0,0,3.1-1.79,6.83,6.83,0,0,0-3.1-5.37,1.89,1.89,0,0,0-3.1,1.79A6.86,6.86,0,0,0,435,193.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--sphere-12--inject-103",
    d: "M433.25,187.91a1.39,1.39,0,0,1,1.4.13,4.36,4.36,0,0,1,2,3.42,1.39,1.39,0,0,1-.58,1.28,2.79,2.79,0,1,1-2.79-4.83Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.62,191.46a4.28,4.28,0,0,0-1-2.53,2.62,2.62,0,0,1-.06,2.61,2.28,2.28,0,0,1-3.25.31,2.77,2.77,0,0,0,3.72.89A1.39,1.39,0,0,0,436.62,191.46Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.22,190.85a1.35,1.35,0,0,0,1.61,1.07c.38-.08.67-.32.6-.73a.8.8,0,0,0-.43-.58,5.08,5.08,0,0,1-.7-.35c-.22-.15-.32-.37-.62-.38s-.45.37-.47.63A1.9,1.9,0,0,0,432.22,190.85Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.52,190.91a.48.48,0,0,0-.24.3.37.37,0,0,0,.11.36.47.47,0,0,0,.28.09.51.51,0,0,0,.21,0,.41.41,0,0,0,.19-.59A.38.38,0,0,0,433.52,190.91Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.14,91.57l45.38,26.19,1-1.71L392.12,89.87h0a.49.49,0,0,0-.49,0,1.54,1.54,0,0,0-.69,1.21A.48.48,0,0,0,391.14,91.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.7,116.5a1.57,1.57,0,0,1-.69,1.21c-.39.22-.7,0-.7-.4a1.56,1.56,0,0,1,.69-1.21C437.38,115.88,437.7,116.06,437.7,116.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.76,112.24a2.18,2.18,0,0,0-.91,2,6.87,6.87,0,0,0,3.1,5.37,2.19,2.19,0,0,0,2.2.21l2-1.14a2.18,2.18,0,0,0,.91-2,6.87,6.87,0,0,0-3.1-5.37,2.17,2.17,0,0,0-2.19-.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,119.62a1.89,1.89,0,0,0,3.1-1.79,6.81,6.81,0,0,0-3.1-5.37,2.15,2.15,0,0,0-2.19-.22,2.18,2.18,0,0,0-.91,2A6.87,6.87,0,0,0,435,119.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--sphere-12--inject-103",
    d: "M433.25,113.8a1.37,1.37,0,0,1,1.4.14,4.36,4.36,0,0,1,2,3.42,1.36,1.36,0,0,1-.58,1.27,2.79,2.79,0,0,1-2.79-4.83Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.62,117.36a4.31,4.31,0,0,0-1-2.54,2.64,2.64,0,0,1-.06,2.62,2.29,2.29,0,0,1-3.25.3,2.77,2.77,0,0,0,3.72.89A1.36,1.36,0,0,0,436.62,117.36Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.22,116.75a1.35,1.35,0,0,0,1.61,1.06c.38-.08.67-.32.6-.73a.8.8,0,0,0-.43-.58,5,5,0,0,1-.7-.34c-.22-.16-.32-.38-.62-.39s-.45.37-.47.64A2,2,0,0,0,432.22,116.75Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.52,116.8a.49.49,0,0,0-.24.31.36.36,0,0,0,.11.35.47.47,0,0,0,.28.09.5.5,0,0,0,.21,0,.42.42,0,0,0,.19-.6A.38.38,0,0,0,433.52,116.8Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.22,75.11l-.44,1.11a1,1,0,0,1-1.89,0l-.44-1.11a9.93,9.93,0,0,1-.67-3.58v-5.7h4.11v5.7A9.93,9.93,0,0,1,389.22,75.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,75.29a7.31,7.31,0,0,0,.18-2.23V65.83h-.37v7.31A5.91,5.91,0,0,0,388,75.29Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.36,65.83h-.74v9h0a7.25,7.25,0,0,0,.74-3.2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.31,65.84V67A2.2,2.2,0,0,1,391,68.78a7,7,0,0,1-6.33,0,2.8,2.8,0,0,1-1-.86,1.62,1.62,0,0,1-.33-1V65.83a1,1,0,0,1,0-.3A2.37,2.37,0,0,1,384.67,64s0,0,.06,0A7,7,0,0,1,391,64a2.42,2.42,0,0,1,1.28,1.53A1.55,1.55,0,0,1,392.31,65.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.2,68.41V66.76c0-.65.17-1.64-1-1.64A3.19,3.19,0,0,1,384.73,64s0,0-.06,0a2.37,2.37,0,0,0-1.27,1.53,1,1,0,0,0,0,.3V67a1.62,1.62,0,0,0,.33,1,2.8,2.8,0,0,0,1,.86,7,7,0,0,0,6.33,0C389.77,69.27,388.2,69,388.2,68.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.67,67.66c-1.75-1-1.75-2.65,0-3.66A7,7,0,0,1,391,64c1.75,1,1.75,2.65,0,3.66A7,7,0,0,1,384.67,67.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.31,62.42v2.79a1.73,1.73,0,0,1,0,.32A2.4,2.4,0,0,1,391,67.05a6.19,6.19,0,0,1-2.8.74,6.63,6.63,0,0,1-3.53-.74,3.1,3.1,0,0,1-1-.85,1.58,1.58,0,0,1-.29-.67,1,1,0,0,1,0-.3V62.41a2.22,2.22,0,0,1,1.31-1.83l.24-.13a7,7,0,0,1,6.09.13A2.2,2.2,0,0,1,392.31,62.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.69,66.2a3.1,3.1,0,0,0,1,.85,6.63,6.63,0,0,0,3.53.74v-1c0-.65.19-1.41-1-1.64a4.65,4.65,0,0,1-3.08-1.65,2.26,2.26,0,0,1,.77-3l-.24.13a2.22,2.22,0,0,0-1.31,1.83v2.82a1,1,0,0,0,0,.3A1.58,1.58,0,0,0,383.69,66.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.09,168.66l-.44,1.12a1,1,0,0,1-1.89,0l-.43-1.12a9.68,9.68,0,0,1-.68-3.57v-5.7h4.11v5.7A9.88,9.88,0,0,1,420.09,168.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.9,168.85a7.31,7.31,0,0,0,.18-2.23v-7.23h-.37v7.31A6,6,0,0,0,418.9,168.85Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.23,159.39h-.74v9h0a7.25,7.25,0,0,0,.74-3.2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.18,159.4v1.11a2.2,2.2,0,0,1-1.31,1.83,7,7,0,0,1-6.33,0,2.8,2.8,0,0,1-1-.86,1.67,1.67,0,0,1-.33-1v-1.12a1,1,0,0,1,0-.3,2.37,2.37,0,0,1,1.27-1.53l.06,0a7,7,0,0,1,6.27,0,2.43,2.43,0,0,1,1.28,1.52A1.73,1.73,0,0,1,423.18,159.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.07,162v-1.65c0-.65.17-1.64-1-1.64a3.17,3.17,0,0,1-2.49-1.16l-.06,0a2.37,2.37,0,0,0-1.27,1.53,1,1,0,0,0,0,.3v1.12a1.67,1.67,0,0,0,.33,1,2.8,2.8,0,0,0,1,.86,7,7,0,0,0,6.33,0C420.64,162.83,419.07,162.59,419.07,162Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.54,161.21c-1.75-1-1.75-2.64,0-3.65a7,7,0,0,1,6.33,0c1.75,1,1.75,2.65,0,3.65A7,7,0,0,1,415.54,161.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.18,156v2.8a1.55,1.55,0,0,1,0,.31,2.42,2.42,0,0,1-1.28,1.53,6.19,6.19,0,0,1-2.8.74,6.54,6.54,0,0,1-3.53-.75,2.87,2.87,0,0,1-1-.85,1.67,1.67,0,0,1-.29-.66,1.1,1.1,0,0,1,0-.31V156a2.22,2.22,0,0,1,1.31-1.82l.24-.13a7,7,0,0,1,6.09.13A2.19,2.19,0,0,1,423.18,156Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.56,159.75a2.87,2.87,0,0,0,1,.85,6.54,6.54,0,0,0,3.53.75v-1c0-.65.2-1.41-1-1.64A4.62,4.62,0,0,1,415,157a2.25,2.25,0,0,1,.77-3l-.24.13a2.22,2.22,0,0,0-1.31,1.82v2.82a1.1,1.1,0,0,0,0,.31A1.67,1.67,0,0,0,414.56,159.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.07,71.25a13.72,13.72,0,0,0-6.3-10.91L394.25,49.06c-1.93-1.11-3.81-1.25-5.3-.39s-2.3,2.56-2.3,4.78V62h0a.66.66,0,0,0,.38.53,2.05,2.05,0,0,0,1.84,0,.64.64,0,0,0,.38-.53h0V53.45a2.19,2.19,0,0,1,3.69-2.13L412.47,62.6a11.23,11.23,0,0,1,5,8.65v84.67h0a.64.64,0,0,0,.38.54,2.05,2.05,0,0,0,1.84,0,.66.66,0,0,0,.38-.54h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.07,71.25a13.72,13.72,0,0,0-6.3-10.91L394.25,49.06c-1.93-1.11-3.81-1.25-5.3-.39s-2.3,2.56-2.3,4.78V62h0a.66.66,0,0,0,.38.53,2.05,2.05,0,0,0,1.84,0,.64.64,0,0,0,.38-.53h0V53.45a2.19,2.19,0,0,1,3.69-2.13L412.47,62.6a11.23,11.23,0,0,1,5,8.65v84.67h0a.64.64,0,0,0,.38.54,2.05,2.05,0,0,0,1.84,0,.66.66,0,0,0,.38-.54h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,62.12a1.26,1.26,0,0,1-.59-.13l-.06,0v-.58h0V53.45c0-2,.7-3.48,2-4.22a3.54,3.54,0,0,1,1.79-.47,5.78,5.78,0,0,1,2.85.87l19.53,11.28a13,13,0,0,1,6,10.34v84.6l-.06,0a1.26,1.26,0,0,1-.59.13,1.33,1.33,0,0,1-.6-.13l-.05,0V71.25A11.78,11.78,0,0,0,412.8,62L393.27,50.76a4.46,4.46,0,0,0-2.19-.68,2.28,2.28,0,0,0-1.15.28,3.36,3.36,0,0,0-1.33,3.09V62l-.05,0A1.33,1.33,0,0,1,388,62.12Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.07,134.61v.44c0,.18-.13.35-.38.49a2.14,2.14,0,0,1-1.85,0,.62.62,0,0,1-.37-.46.14.14,0,0,1,0-.09v-.36h0a.75.75,0,0,0-.14.24.51.51,0,0,0,0,.17v2.55a.59.59,0,0,0,.18.41.8.8,0,0,0,.26.21,2.29,2.29,0,0,0,2.1,0,1,1,0,0,0,.24-.19.6.6,0,0,0,.19-.43V135A.62.62,0,0,0,420.07,134.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.07,134.61v.44c0,.18-.13.35-.38.49a2.14,2.14,0,0,1-1.85,0,.62.62,0,0,1-.37-.46.14.14,0,0,1,0-.09v-.36h0a.6.6,0,0,0-.14.24.4.4,0,0,0,0,.15v0a.64.64,0,0,0,.18.38.8.8,0,0,0,.26.21,2.29,2.29,0,0,0,2.1,0,1,1,0,0,0,.24-.19.58.58,0,0,0,0-.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,137.86l14.84,8.55,1-1.7L420,136.15h0a.49.49,0,0,0-.49,0,1.54,1.54,0,0,0-.69,1.21A.51.51,0,0,0,419,137.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,145.16a1.54,1.54,0,0,1-.69,1.2c-.38.22-.69,0-.7-.4a1.54,1.54,0,0,1,.69-1.2C434.69,144.54,435,144.71,435,145.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.76,141.62a2.19,2.19,0,0,0-.91,2A6.86,6.86,0,0,0,435,149a2.19,2.19,0,0,0,2.2.22l2-1.14a2.19,2.19,0,0,0,.91-2,6.86,6.86,0,0,0-3.1-5.37,2.2,2.2,0,0,0-2.19-.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,149a1.89,1.89,0,0,0,3.1-1.79,6.83,6.83,0,0,0-3.1-5.37,1.89,1.89,0,0,0-3.1,1.79A6.86,6.86,0,0,0,435,149Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--sphere-12--inject-103",
    d: "M433.25,143.19a1.39,1.39,0,0,1,1.4.13,4.36,4.36,0,0,1,2,3.42A1.39,1.39,0,0,1,436,148a2.79,2.79,0,1,1-2.79-4.83Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.62,146.74a4.28,4.28,0,0,0-1-2.53,2.62,2.62,0,0,1-.06,2.61,2.28,2.28,0,0,1-3.25.31A2.78,2.78,0,0,0,436,148,1.39,1.39,0,0,0,436.62,146.74Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.22,146.13a1.35,1.35,0,0,0,1.61,1.07c.38-.08.67-.32.6-.73a.8.8,0,0,0-.43-.58,5.08,5.08,0,0,1-.7-.35c-.22-.15-.32-.37-.62-.38s-.45.37-.47.63A1.9,1.9,0,0,0,432.22,146.13Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.52,146.19a.48.48,0,0,0-.24.3.37.37,0,0,0,.11.36.47.47,0,0,0,.28.09.51.51,0,0,0,.21,0,.42.42,0,0,0,.19-.6A.39.39,0,0,0,433.52,146.19Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Beaker--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-103",
    d: "M373,254.15c-7.42,4.39-7.42,11.5,0,15.88s19.46,4.38,26.88,0,7.42-11.49,0-15.88S380.46,249.77,373,254.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--beaker--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.29,260.78h0V233.71H370.81v27.07h0c0,2.34,1.52,4.68,4.61,6.46,6.15,3.55,16.11,3.55,22.26,0C400.77,265.46,402.3,263.12,402.29,260.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.29,260.78h0V233.71H370.81v27.07h0c0,2.34,1.52,4.68,4.61,6.46,6.15,3.55,16.11,3.55,22.26,0C400.77,265.46,402.3,263.12,402.29,260.78Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.68,267.24c3.09-1.78,4.62-4.12,4.61-6.46h0V233.71h-.2A12.61,12.61,0,0,1,395.4,241c0,14.7,1,28.43-10.2,28.43a25.7,25.7,0,0,1-6.91-.87C384.36,270.71,392.42,270.28,397.68,267.24Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.83,247v13.71h0c0,2,1.33,4,4,5.59,5.34,3.08,14,3.08,19.34,0,2.67-1.54,4-3.57,4-5.59V247Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.23,260.73V247h-4.8c0,10-.38,18.56-5.75,21.4a17.91,17.91,0,0,0,6.54-2.1C398.89,264.78,400.23,262.75,400.23,260.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.84,252.61c-5.35-3.09-5.35-8.1,0-11.19s14-3.09,19.38,0,5.35,8.1,0,11.19S382.19,255.7,376.84,252.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.79,252.2a3.81,3.81,0,0,1-.23-.5,1.72,1.72,0,0,0-1-.81,4.64,4.64,0,0,0-1.34-.15c-1.47,0-7,.79-6.91-1.76,0-1,1.74-2.1.53-3.1a2,2,0,0,0-.48-.25c-2.17-.8-4.54-.17-6.72-.89a1.47,1.47,0,0,1-.75-.47,1.37,1.37,0,0,1-.17-1,5.06,5.06,0,0,1,2.17-3.18,15.22,15.22,0,0,0-3,1.31c-5.35,3.09-5.35,8.1,0,11.19s13.79,3.09,19.15.12h-.09A1.41,1.41,0,0,1,394.79,252.2Zm-.62-2.26a.45.45,0,0,0,.14.26,2.07,2.07,0,0,0,1.71.44,1.62,1.62,0,0,0,.75-.21.55.55,0,0,0,.31-.49C397,248.91,394.1,249.06,394.17,249.94Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.54 236.61 401.54 261.03 400.79 262.72 400.79 237.45 401.54 236.61",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.2,237.2v22.85c0,3.1,4.17,8.45,14.33,8.63a25,25,0,0,1-7.35-2.78,7.29,7.29,0,0,1-3.59-6.3V238.93Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ring--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.16,225a15.39,15.39,0,0,1-1.92.05,14.2,14.2,0,0,1-2.74-.57,24.91,24.91,0,0,0-6-.72,21.8,21.8,0,0,0-10.78,2.61c-3.25,1.87-5,4.47-5,7.33s1.78,5.46,5,7.33a23.57,23.57,0,0,0,21.56,0c3.24-1.87,5-4.47,5-7.33a7.2,7.2,0,0,0-1.36-4.12,8.2,8.2,0,0,1-1.15-1.8,9.45,9.45,0,0,1-.32-2.11.91.91,0,0,0-.16-.51,1.09,1.09,0,0,0-.89-.25C398,224.94,397.58,225,397.16,225Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.16,225a15.39,15.39,0,0,1-1.92.05,14.2,14.2,0,0,1-2.74-.57,24.91,24.91,0,0,0-6-.72,21.8,21.8,0,0,0-10.78,2.61c-3.25,1.87-5,4.47-5,7.33s1.78,5.46,5,7.33a23.57,23.57,0,0,0,21.56,0c3.24-1.87,5-4.47,5-7.33a7.2,7.2,0,0,0-1.36-4.12,8.2,8.2,0,0,1-1.15-1.8,9.45,9.45,0,0,1-.32-2.11.91.91,0,0,0-.16-.51,1.09,1.09,0,0,0-.89-.25C398,224.94,397.58,225,397.16,225Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.9,239.37c-5.75,3.32-15.09,3.32-20.84,0s-5.76-8.72,0-12a20.06,20.06,0,0,1,8.56-2.43,24.75,24.75,0,0,1,6.6.38,21.7,21.7,0,0,0,3.66.62c.72,0,1.43,0,2.15-.09.36,0,.72,0,1.08,0s.53,0,.64.31a.86.86,0,0,1,0,.39,3.52,3.52,0,0,0,.18,1.83,3.14,3.14,0,0,0,.33.48,19.36,19.36,0,0,1,1.23,2,5.41,5.41,0,0,1,.68,2.78C401.1,236.16,399,238.14,396.9,239.37Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.21,233.55c-.11,2.61-2.19,4.59-4.31,5.82-.36.2-.74.4-1.13.58a23.62,23.62,0,0,1-18.57,0,12.2,12.2,0,0,1-1.14-.59c-5.76-3.33-5.76-8.72,0-12a20.06,20.06,0,0,1,8.56-2.43,24.72,24.72,0,0,1,6.6.38,20.74,20.74,0,0,0,3.66.62c.72,0,1.43,0,2.15-.09.36,0,.72,0,1.08,0s.52,0,.64.31a.86.86,0,0,1,0,.39,3.52,3.52,0,0,0,.18,1.83,3.73,3.73,0,0,0,.33.48,19.36,19.36,0,0,1,1.23,2A5.41,5.41,0,0,1,401.21,233.55Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.3,228.78a3.73,3.73,0,0,1-.33-.48,3.52,3.52,0,0,1-.18-1.83.86.86,0,0,0,0-.39c-.12-.29-.37-.31-.64-.31s-.72,0-1.08,0c-.72.05-1.43.11-2.15.09a20.59,20.59,0,0,1-3.66-.62,24.72,24.72,0,0,0-6.6-.38,21,21,0,0,0-7.55,1.89c7.55-1.89,14.27.29,16.12,1.88s.83,6.5,2,5.47,2.93-2.32,3.6-1.3c.39.61.32,2.46.2,5a6.25,6.25,0,0,0,2.21-4.28,5.41,5.41,0,0,0-.68-2.78A19.36,19.36,0,0,0,399.3,228.78Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.26,241a9.88,9.88,0,0,0,4.63-5c-.35.86-1.57,3.26-5.56,5a26.19,26.19,0,0,1-19.63-.15c-6.19-2.82-6.09-8.19-5.14-10.46h0a7,7,0,0,0-.87,3.35c0,2.86,1.78,5.46,5,7.33a23.57,23.57,0,0,0,21.56,0Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.26,241a9.88,9.88,0,0,0,4.63-5c-.35.86-1.57,3.26-5.56,5a26.19,26.19,0,0,1-19.63-.15c-6.19-2.82-6.09-8.19-5.14-10.46h0a7,7,0,0,0-.87,3.35c0,2.86,1.78,5.46,5,7.33a23.57,23.57,0,0,0,21.56,0Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M378.66,240.56a24.23,24.23,0,0,0,15.71,0A22.31,22.31,0,0,0,378.66,240.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.48,247.4c-7.53,0-11.3-2.61-13.49-4.59a.2.2,0,0,1,0-.28.21.21,0,0,1,.29,0c2.18,2,6,4.57,13.6,4.48a.21.21,0,0,1,.21.2.22.22,0,0,1-.2.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,250.61h0a17.17,17.17,0,0,1-8-4,.21.21,0,1,1,.27-.31,16.75,16.75,0,0,0,7.8,4,.21.21,0,0,1,.16.24A.2.2,0,0,1,381,250.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.48,254.91c-7.53,0-11.3-2.61-13.49-4.59a.21.21,0,0,1,0-.29.21.21,0,0,1,.29,0c2.18,2,6,4.57,13.6,4.48a.2.2,0,0,1,.21.2.2.2,0,0,1-.2.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,258.12h0a17.17,17.17,0,0,1-8-4,.22.22,0,0,1,0-.29.21.21,0,0,1,.29,0,16.75,16.75,0,0,0,7.8,4,.21.21,0,0,1,.16.24A.2.2,0,0,1,381,258.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.48,262.41c-7.53,0-11.3-2.6-13.49-4.58a.22.22,0,0,1,0-.29.21.21,0,0,1,.29,0c2.18,2,6,4.56,13.6,4.48a.2.2,0,0,1,.21.2.2.2,0,0,1-.2.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,265.63h0a17.28,17.28,0,0,1-8-4.05.2.2,0,0,1,0-.28.21.21,0,0,1,.29,0,16.84,16.84,0,0,0,7.8,4,.21.21,0,0,1,.16.24A.2.2,0,0,1,381,265.63Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tubes--inject-103"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "352.9 257.04 322.23 239.33 328.55 235.68 359.22 253.39 352.9 257.04",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.77,225h0l-.41-.24v.69a1.18,1.18,0,0,0,.24.7,1.57,1.57,0,0,0,.17.21v3a2.17,2.17,0,0,1,.52-.4,5,5,0,0,1,4.51,0,2.65,2.65,0,0,1,.57.43v-1.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.08,225.46a5,5,0,0,1,4.51,0,1.88,1.88,0,0,1,.87.94c.2-.59-.08-1.22-.87-1.67a5,5,0,0,0-4.51,0c-.79.45-1.08,1.09-.87,1.67A1.88,1.88,0,0,1,342.08,225.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.86,221.3a5,5,0,0,1,4.51,0,1.82,1.82,0,0,1,.87.93c.21-.58-.08-1.21-.87-1.67a5,5,0,0,0-4.51,0c-.78.46-1.07,1.09-.87,1.67A1.82,1.82,0,0,1,334.86,221.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.65,217.13a5,5,0,0,1,4.51,0,1.82,1.82,0,0,1,.86.94c.21-.59-.08-1.22-.86-1.67a5,5,0,0,0-4.51,0c-.79.45-1.08,1.08-.88,1.67A1.82,1.82,0,0,1,327.65,217.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.3,229.63a5,5,0,0,1,4.51,0,1.8,1.8,0,0,1,.87.94c.2-.59-.09-1.22-.87-1.67a5,5,0,0,0-4.51,0c-.79.45-1.08,1.08-.87,1.67A1.76,1.76,0,0,1,349.3,229.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.64,216.4a5,5,0,0,1,4.52,0,2.26,2.26,0,0,1,.53.41v-1.15l-4.14-2.39-1.46.84v2.72A2.44,2.44,0,0,1,327.64,216.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.38,216.64h0l-.05,0h0l-.41-.23v.69a1.21,1.21,0,0,0,.24.7,1.51,1.51,0,0,0,.17.2h0v3a2.41,2.41,0,0,1,.54-.42,5,5,0,0,1,4.51,0,2.41,2.41,0,0,1,.54.42v-1.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.63,220.83h0l-.49-.29v.69a1.24,1.24,0,0,0,.23.7l.17.21h0v3a2.13,2.13,0,0,1,.54-.41,5,5,0,0,1,4.51,0,2.24,2.24,0,0,1,.55.43V224Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,218.51l0,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.06,218.53l.14.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.08,242.13a5,5,0,0,1,4.51,0,1.82,1.82,0,0,1,.87.93c.2-.58-.08-1.21-.87-1.67a5,5,0,0,0-4.51,0c-.79.46-1.08,1.09-.87,1.67A1.82,1.82,0,0,1,342.08,242.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.86,238a5,5,0,0,1,4.51,0,1.8,1.8,0,0,1,.87.94c.21-.59-.08-1.22-.87-1.67a5,5,0,0,0-4.51,0c-.78.45-1.07,1.08-.87,1.67A1.8,1.8,0,0,1,334.86,238Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.65,233.8a5,5,0,0,1,4.51,0,1.8,1.8,0,0,1,.86.93c.21-.59-.08-1.22-.86-1.67a5,5,0,0,0-4.51,0c-.79.45-1.08,1.09-.88,1.67A1.81,1.81,0,0,1,327.65,233.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.3,246.29a5,5,0,0,1,4.51,0,1.84,1.84,0,0,1,.87.94c.2-.59-.09-1.22-.87-1.67a5,5,0,0,0-4.51,0c-.79.45-1.08,1.08-.87,1.67A1.8,1.8,0,0,1,349.3,246.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.64,233.06a5,5,0,0,1,4.52,0,2.26,2.26,0,0,1,.53.41v-1.15l-4.14-2.39-1.46.84v2.72A2.44,2.44,0,0,1,327.64,233.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.86,237.22a5,5,0,0,1,4.51,0,2.41,2.41,0,0,1,.54.42V236.5l-5.59-3.23v4.38A2.18,2.18,0,0,1,334.86,237.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.08,241.39a5,5,0,0,1,4.51,0,2.5,2.5,0,0,1,.55.43v-1.15l-5.6-3.23v4.36A2.72,2.72,0,0,1,342.08,241.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.29,245.56a5,5,0,0,1,4.51,0,2.39,2.39,0,0,1,.57.44v-1.16l-5.6-3.23V246A2.46,2.46,0,0,1,349.29,245.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--test-tube--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.69,213.2a1.38,1.38,0,0,0-.82-1.14,4.36,4.36,0,0,0-3.95,0,1.38,1.38,0,0,0-.82,1.14v25h0a2.8,2.8,0,0,0,5.59,0h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.69,213.2a1.38,1.38,0,0,0-.82-1.14,4.36,4.36,0,0,0-3.95,0,1.38,1.38,0,0,0-.82,1.14v25h0a2.8,2.8,0,0,0,5.59,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.85,217.9a1,1,0,0,0-.57-.8,3.07,3.07,0,0,0-2.77,0,1,1,0,0,0-.57.8v20.18h0a2,2,0,1,0,3.91,0h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M329.89,240a2,2,0,0,0,2-1.87,1.36,1.36,0,0,1-2.68-.37h0v-21a2.59,2.59,0,0,0-.66.25,1,1,0,0,0-.57.8v20.18h0A2,2,0,0,0,329.89,240Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M331.85,217.9c0,.63-.87,1.13-2,1.13s-1.95-.5-1.95-1.13.87-1.13,1.95-1.13S331.85,217.28,331.85,217.9Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.85,217.9c0,.63-.87,1.13-2,1.13s-1.95-.5-1.95-1.13.87-1.13,1.95-1.13S331.85,217.28,331.85,217.9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.85,217.9a1,1,0,0,0-.57-.8.85.85,0,0,1-.4,1.48,2.73,2.73,0,0,1-2.87-.38,2.06,2.06,0,0,0,1.88.83C331,219,331.85,218.53,331.85,217.9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.62,239c0,.27.16.41.36.28a1,1,0,0,0,.34-.75V212.4a2,2,0,0,0-.45-.34l-.25-.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.08,239.64h0a.28.28,0,0,0,.2-.26V211.8l-.41-.11v27.79A.15.15,0,0,0,331.08,239.64Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,214.76a1.92,1.92,0,0,0,.7-.64v-.92a.79.79,0,0,0-.05-.3,2,2,0,0,0-.65-.56,4.68,4.68,0,0,0-3.94-.13V212l0,0-.1.05a1.89,1.89,0,0,0-.56.46,1.16,1.16,0,0,0-.21.37.87.87,0,0,0,0,.31v1.1h0v3.23h0v20.65h0a2.8,2.8,0,0,0,5.36,1.12,2.6,2.6,0,0,1-3,1.06h0a1.58,1.58,0,0,1-1.14-1.52V215A4.71,4.71,0,0,0,332,214.76Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.61,241h0a2.42,2.42,0,0,1-2-2.58V212.3l0,0a1.4,1.4,0,0,0-.31.39v0a.36.36,0,0,0,0,.09v0a.65.65,0,0,0-.05.2v1.23h0v3.23h0v20.65h0A2.79,2.79,0,0,0,329.61,241Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.1,211.5a1.58,1.58,0,0,0-.94-1.3,5,5,0,0,0-4.53,0,1.58,1.58,0,0,0-.94,1.3h0v1.39h0a1.6,1.6,0,0,0,.94,1.31,5,5,0,0,0,4.53,0,1.6,1.6,0,0,0,.94-1.31h0V211.5Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.1,211.5a1.58,1.58,0,0,0-.94-1.3,5,5,0,0,0-4.53,0,1.58,1.58,0,0,0-.94,1.3h0v1.39h0a1.6,1.6,0,0,0,.94,1.31,5,5,0,0,0,4.53,0,1.6,1.6,0,0,0,.94-1.31h0V211.5Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.37,214.06a5.55,5.55,0,0,1-3.63.26c-1-.42-1.48-.84-1.48-1.79v-2.08a1.4,1.4,0,0,0-.57,1.05h0v1.39h0a1.6,1.6,0,0,0,.94,1.31,5,5,0,0,0,4.53,0Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.63,212.81a5,5,0,0,0,4.53,0,1.38,1.38,0,0,0,0-2.61,5,5,0,0,0-4.53,0A1.38,1.38,0,0,0,327.63,212.81Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.63,212.81a5,5,0,0,0,4.53,0,1.38,1.38,0,0,0,0-2.61,5,5,0,0,0-4.53,0A1.38,1.38,0,0,0,327.63,212.81Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.49,210.43c-1,.26-1.34,1-.9,1.62a2.75,2.75,0,0,0,2.79.88c1.5-.2,1.81-1,1.81-1.2Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.24,212.46a3.71,3.71,0,0,0,3.31,0,1,1,0,0,0,0-1.91,3.71,3.71,0,0,0-3.31,0A1,1,0,0,0,328.24,212.46Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.24,212.46a3.71,3.71,0,0,0,3.31,0,1,1,0,0,0,0-1.91,3.71,3.71,0,0,0-3.31,0A1,1,0,0,0,328.24,212.46Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.24,212.2l-.19.13.19.13a3.71,3.71,0,0,0,3.31,0l.19-.13-.19-.13A3.64,3.64,0,0,0,328.24,212.2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--test-tube--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.92,217.37a1.41,1.41,0,0,0-.82-1.14,4.38,4.38,0,0,0-4,0,1.39,1.39,0,0,0-.82,1.14v25h0a2.8,2.8,0,1,0,5.6,0h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.92,217.37a1.41,1.41,0,0,0-.82-1.14,4.38,4.38,0,0,0-4,0,1.39,1.39,0,0,0-.82,1.14v25h0a2.8,2.8,0,1,0,5.6,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.08,222.07a1,1,0,0,0-.58-.8,3.07,3.07,0,0,0-2.77,0,1,1,0,0,0-.57.8v20.18h0a2,2,0,0,0,3.92,0h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M337.12,244.21a2,2,0,0,0,1.95-1.86,1.37,1.37,0,0,1-2.68-.38h0V221a2.74,2.74,0,0,0-.66.25,1,1,0,0,0-.57.8v20.18h0A2,2,0,0,0,337.12,244.21Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M339.08,222.07c0,.63-.88,1.13-2,1.13s-2-.5-2-1.13.88-1.13,2-1.13S339.08,221.45,339.08,222.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.08,222.07c0,.63-.88,1.13-2,1.13s-2-.5-2-1.13.88-1.13,2-1.13S339.08,221.45,339.08,222.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.08,222.07a1,1,0,0,0-.57-.79.85.85,0,0,1-.4,1.47,2.71,2.71,0,0,1-2.88-.38,2.1,2.1,0,0,0,1.89.83C338.2,223.2,339.08,222.7,339.08,222.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M338.84,243.12c0,.28.17.41.36.28a1,1,0,0,0,.34-.75V216.57a2.68,2.68,0,0,0-.44-.34l-.26-.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.3,243.81h0a.29.29,0,0,0,.19-.26V216l-.4-.11v27.8A.15.15,0,0,0,338.3,243.81Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.22,218.93a2,2,0,0,0,.7-.64v-.92a.93.93,0,0,0-.05-.29,2,2,0,0,0-.65-.57,4.73,4.73,0,0,0-4-.13v-.22l0,0-.1,0a2.06,2.06,0,0,0-.56.46,1.11,1.11,0,0,0-.21.38,1,1,0,0,0-.05.3v1.1h0v3.24h0v20.64h0a2.8,2.8,0,0,0,5.36,1.13,2.58,2.58,0,0,1-3,1.05h0a1.58,1.58,0,0,1-1.13-1.53V219.18A4.68,4.68,0,0,0,339.22,218.93Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.83,245.13h0a2.42,2.42,0,0,1-2-2.58V216.48l0,0a1.45,1.45,0,0,0-.32.39v0a.36.36,0,0,1,0,.09v0a1.94,1.94,0,0,0-.05.2v0a.34.34,0,0,0,0,.1v1.1h0v3.24h0v20.64h0A2.79,2.79,0,0,0,336.83,245.13Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.32,215.68a1.58,1.58,0,0,0-.94-1.31,5,5,0,0,0-4.53,0,1.6,1.6,0,0,0-.94,1.31h0v1.38h0a1.61,1.61,0,0,0,.94,1.31,5,5,0,0,0,4.53,0,1.59,1.59,0,0,0,.94-1.31h0v-1.38Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.32,215.68a1.58,1.58,0,0,0-.94-1.31,5,5,0,0,0-4.53,0,1.6,1.6,0,0,0-.94,1.31h0v1.38h0a1.61,1.61,0,0,0,.94,1.31,5,5,0,0,0,4.53,0,1.59,1.59,0,0,0,.94-1.31h0v-1.38Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.59,218.23a5.46,5.46,0,0,1-3.62.26c-1-.42-1.48-.84-1.48-1.79v-2.08a1.42,1.42,0,0,0-.58,1.06h0v1.38h0a1.61,1.61,0,0,0,.94,1.31,5,5,0,0,0,4.53,0A1.1,1.1,0,0,0,339.59,218.23Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.85,217a5,5,0,0,0,4.53,0,1.38,1.38,0,0,0,0-2.61,5,5,0,0,0-4.53,0A1.38,1.38,0,0,0,334.85,217Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.85,217a5,5,0,0,0,4.53,0,1.38,1.38,0,0,0,0-2.61,5,5,0,0,0-4.53,0A1.38,1.38,0,0,0,334.85,217Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.72,214.6c-1,.26-1.34,1-.9,1.62a2.75,2.75,0,0,0,2.78.89c1.51-.2,1.82-1,1.82-1.2Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.47,216.63a3.62,3.62,0,0,0,3.3,0,1,1,0,0,0,0-1.91,3.69,3.69,0,0,0-3.3,0A1,1,0,0,0,335.47,216.63Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.47,216.63a3.62,3.62,0,0,0,3.3,0,1,1,0,0,0,0-1.91,3.69,3.69,0,0,0-3.3,0A1,1,0,0,0,335.47,216.63Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.47,216.37l-.2.13a1.37,1.37,0,0,0,.2.13,3.62,3.62,0,0,0,3.3,0l.19-.13-.19-.13A3.69,3.69,0,0,0,335.47,216.37Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--test-tube--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.14,221.55a1.39,1.39,0,0,0-.82-1.15,4.38,4.38,0,0,0-4,0,1.41,1.41,0,0,0-.82,1.15v25h0a2.8,2.8,0,0,0,5.6,0h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.14,221.55a1.39,1.39,0,0,0-.82-1.15,4.38,4.38,0,0,0-4,0,1.41,1.41,0,0,0-.82,1.15v25h0a2.8,2.8,0,0,0,5.6,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.3,226.25a1,1,0,0,0-.57-.8,3,3,0,0,0-2.77,0,1,1,0,0,0-.58.8v20.17h0a2,2,0,0,0,3.92,0h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M344.34,248.38a2,2,0,0,0,2-1.86,1.38,1.38,0,0,1-1.32,1,1.36,1.36,0,0,1-1.36-1.36h0V225.2a2,2,0,0,0-.66.25,1,1,0,0,0-.58.8v20.17h0A2,2,0,0,0,344.34,248.38Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M346.3,226.25c0,.62-.88,1.13-2,1.13s-2-.51-2-1.13.88-1.13,2-1.13S346.3,225.62,346.3,226.25Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.3,226.25c0,.62-.88,1.13-2,1.13s-2-.51-2-1.13.88-1.13,2-1.13S346.3,225.62,346.3,226.25Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.3,226.25a1,1,0,0,0-.57-.8.86.86,0,0,1-.4,1.48,2.73,2.73,0,0,1-2.88-.39,2.1,2.1,0,0,0,1.89.84C345.42,227.38,346.3,226.87,346.3,226.25Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M346.06,247.29c0,.28.17.41.36.28a1,1,0,0,0,.34-.75V220.74a2.31,2.31,0,0,0-.44-.34l-.26-.12Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.53,248h0a.28.28,0,0,0,.19-.26V220.15a2.62,2.62,0,0,0-.4-.11v27.79A.15.15,0,0,0,345.53,248Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.44,223.11a1.85,1.85,0,0,0,.7-.65v-.91a1,1,0,0,0-.05-.3,2,2,0,0,0-.65-.57,4.71,4.71,0,0,0-3.94-.13v-.21h0l-.1.05a2.05,2.05,0,0,0-.56.47,1.53,1.53,0,0,0-.21.37,1.06,1.06,0,0,0,0,.31v1.09h0v3.24h0v20.64h0a2.8,2.8,0,0,0,5.36,1.12,2.56,2.56,0,0,1-2.95,1h0a1.59,1.59,0,0,1-1.13-1.53V223.36A4.72,4.72,0,0,0,346.44,223.11Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.06,249.3h0a2.41,2.41,0,0,1-2-2.58V220.65l0,0a1.51,1.51,0,0,0-.31.39v0a.2.2,0,0,0,0,.08v0a.83.83,0,0,0-.06.21v0s0,.07,0,.11v1.09h0v3.24h0v20.64h0A2.8,2.8,0,0,0,344.06,249.3Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.54,219.85a1.6,1.6,0,0,0-.93-1.31,5,5,0,0,0-4.53,0,1.59,1.59,0,0,0-.94,1.31h0v1.38h0a1.58,1.58,0,0,0,.94,1.31,5,5,0,0,0,4.53,0,1.58,1.58,0,0,0,.93-1.31h0v-1.38Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.54,219.85a1.6,1.6,0,0,0-.93-1.31,5,5,0,0,0-4.53,0,1.59,1.59,0,0,0-.94,1.31h0v1.38h0a1.58,1.58,0,0,0,.94,1.31,5,5,0,0,0,4.53,0,1.58,1.58,0,0,0,.93-1.31h0v-1.38Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.82,222.41a5.49,5.49,0,0,1-3.63.25c-1-.41-1.48-.84-1.48-1.79V218.8a1.37,1.37,0,0,0-.57,1h0v1.38h0a1.58,1.58,0,0,0,.94,1.31,5,5,0,0,0,4.53,0Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.08,221.16a5,5,0,0,0,4.53,0,1.38,1.38,0,0,0,0-2.62,5,5,0,0,0-4.53,0C340.83,219.26,340.83,220.43,342.08,221.16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.08,221.16a5,5,0,0,0,4.53,0,1.38,1.38,0,0,0,0-2.62,5,5,0,0,0-4.53,0C340.83,219.26,340.83,220.43,342.08,221.16Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.94,218.77c-1,.27-1.34,1-.9,1.63a2.75,2.75,0,0,0,2.78.88c1.51-.2,1.82-1,1.82-1.2Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.69,220.8a3.62,3.62,0,0,0,3.3,0,1,1,0,0,0,0-1.9,3.62,3.62,0,0,0-3.3,0A1,1,0,0,0,342.69,220.8Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.69,220.8a3.62,3.62,0,0,0,3.3,0,1,1,0,0,0,0-1.9,3.62,3.62,0,0,0-3.3,0A1,1,0,0,0,342.69,220.8Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.69,220.55l-.19.12.19.13a3.62,3.62,0,0,0,3.3,0,.91.91,0,0,0,.19-.13l-.19-.12A3.62,3.62,0,0,0,342.69,220.55Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--test-tube--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.36,225.72a1.38,1.38,0,0,0-.82-1.14,4.36,4.36,0,0,0-4,0,1.38,1.38,0,0,0-.82,1.14v25h0a2.8,2.8,0,1,0,5.59,0h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.36,225.72a1.38,1.38,0,0,0-.82-1.14,4.36,4.36,0,0,0-4,0,1.38,1.38,0,0,0-.82,1.14v25h0a2.8,2.8,0,1,0,5.59,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.52,230.42a1,1,0,0,0-.57-.8,3.07,3.07,0,0,0-2.77,0,1,1,0,0,0-.57.8v20.17h0a2,2,0,1,0,3.91,0h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M351.56,252.55a2,2,0,0,0,2-1.86,1.37,1.37,0,0,1-2.68-.37h0V229.37a2.26,2.26,0,0,0-.66.25,1,1,0,0,0-.57.8v20.17h0A2,2,0,0,0,351.56,252.55Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M353.52,230.42c0,.62-.87,1.13-2,1.13s-1.95-.51-1.95-1.13.87-1.13,1.95-1.13S353.52,229.79,353.52,230.42Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.52,230.42c0,.62-.87,1.13-2,1.13s-1.95-.51-1.95-1.13.87-1.13,1.95-1.13S353.52,229.79,353.52,230.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.52,230.42a1,1,0,0,0-.57-.8.85.85,0,0,1-.4,1.48,2.73,2.73,0,0,1-2.87-.38,2.06,2.06,0,0,0,1.88.83C352.65,231.55,353.52,231,353.52,230.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M353.29,251.46c0,.28.16.41.36.29A1,1,0,0,0,354,251V224.91a2,2,0,0,0-.45-.33l-.25-.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.75,252.16h0a.29.29,0,0,0,.2-.26V224.32l-.41-.11V252A.16.16,0,0,0,352.75,252.16Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.66,227.28a1.85,1.85,0,0,0,.7-.65v-.91a.79.79,0,0,0-.05-.3,1.93,1.93,0,0,0-.65-.56,4.64,4.64,0,0,0-3.94-.13v-.22h0l-.1.06a1.89,1.89,0,0,0-.56.46,1.07,1.07,0,0,0-.21.37.84.84,0,0,0-.05.31v1.09h0v3.24h0v20.64h0a2.79,2.79,0,0,0,5.35,1.12,2.58,2.58,0,0,1-2.95,1.06h0a1.58,1.58,0,0,1-1.14-1.53V227.53A4.71,4.71,0,0,0,353.66,227.28Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.28,253.48h0a2.43,2.43,0,0,1-2-2.59V224.82l0,0a1.4,1.4,0,0,0-.31.39v0l0,.08v0a.8.8,0,0,0-.05.21v1.22h0v3.24h0v20.64h0A2.81,2.81,0,0,0,351.28,253.48Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.77,224a1.6,1.6,0,0,0-.94-1.31,5,5,0,0,0-4.53,0,1.6,1.6,0,0,0-.94,1.31h0v1.39h0a1.58,1.58,0,0,0,.94,1.3,5,5,0,0,0,4.53,0,1.58,1.58,0,0,0,.94-1.3h0V224Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.77,224a1.6,1.6,0,0,0-.94-1.31,5,5,0,0,0-4.53,0,1.6,1.6,0,0,0-.94,1.31h0v1.39h0a1.58,1.58,0,0,0,.94,1.3,5,5,0,0,0,4.53,0,1.58,1.58,0,0,0,.94-1.3h0V224Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,226.58a5.55,5.55,0,0,1-3.63.26c-1-.42-1.48-.84-1.48-1.8V223a1.37,1.37,0,0,0-.57,1.05h0v1.39h0a1.58,1.58,0,0,0,.94,1.3,5,5,0,0,0,4.53,0Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.3,225.33a5,5,0,0,0,4.53,0c1.25-.72,1.25-1.89,0-2.62a5,5,0,0,0-4.53,0C348.05,223.44,348.05,224.61,349.3,225.33Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.3,225.33a5,5,0,0,0,4.53,0c1.25-.72,1.25-1.89,0-2.62a5,5,0,0,0-4.53,0C348.05,223.44,348.05,224.61,349.3,225.33Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.16,222.94c-1,.27-1.34,1-.89,1.63a2.74,2.74,0,0,0,2.78.88c1.5-.2,1.81-1,1.81-1.2Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.91,225a3.64,3.64,0,0,0,3.31,0,1,1,0,0,0,0-1.9,3.64,3.64,0,0,0-3.31,0A1,1,0,0,0,349.91,225Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.91,225a3.64,3.64,0,0,0,3.31,0,1,1,0,0,0,0-1.9,3.64,3.64,0,0,0-3.31,0A1,1,0,0,0,349.91,225Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.91,224.72l-.19.13.19.12a3.64,3.64,0,0,0,3.31,0l.19-.12-.19-.13A3.64,3.64,0,0,0,349.91,224.72Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "352.9 234.63 322.23 216.92 322.23 217.65 352.9 235.36 359.22 231.71 359.22 230.98 352.9 234.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.9 235.36 352.9 234.63 322.23 216.92 322.23 217.65 352.9 235.36",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.22,231l-6.32,3.65-30.67-17.71,4.86-2.81h0v2.72c-.65.69-.47,1.58.55,2.17a5,5,0,0,0,4.51,0c1-.59,1.21-1.49.54-2.19v-1.15l1.22.71v.69a1.21,1.21,0,0,0,.24.7,1.51,1.51,0,0,0,.17.2v3c-.66.7-.48,1.6.54,2.19a5,5,0,0,0,4.51,0c1-.59,1.21-1.49.54-2.19v-1.15l1.23.71v.69a1.24,1.24,0,0,0,.23.7l.17.21v3c-.67.7-.49,1.6.54,2.19a5,5,0,0,0,4.51,0c1-.59,1.2-1.47.55-2.17V224l1.22.7v.69a1.18,1.18,0,0,0,.24.7,1.57,1.57,0,0,0,.17.21v3c-.68.7-.51,1.6.52,2.2a5,5,0,0,0,4.51,0c1-.59,1.21-1.47.57-2.17v-1.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.9 251.29 322.23 233.58 322.23 234.31 352.9 252.02 359.22 248.38 359.22 247.64 352.9 251.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.23 233.58 352.9 251.29 352.9 252.02 322.23 234.31 322.23 233.58",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.37,244.84V246c.64.69.45,1.58-.57,2.16a5,5,0,0,1-4.51,0c-1-.59-1.2-1.5-.52-2.2v-4.35l-1.63-.94v1.15c.65.7.47,1.59-.55,2.18a5,5,0,0,1-4.51,0c-1-.6-1.21-1.5-.54-2.2v-4.36l-1.63-.94v1.14c.67.7.49,1.6-.54,2.19a5,5,0,0,1-4.51,0c-1-.59-1.2-1.49-.54-2.18v-4.38l-1.63-1v1.15c.67.7.49,1.6-.53,2.19a5,5,0,0,1-4.52,0c-1-.59-1.2-1.47-.55-2.17v-2.72h0l-4.86,2.8,30.67,17.71,6.32-3.65Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stool--inject-103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--stool--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.17,379.24a5.12,5.12,0,0,0,.13,1.15,2.61,2.61,0,0,0,1,1.59l0,0a3,3,0,0,0,3.17-.25,9.64,9.64,0,0,0,4.37-7.56,3.09,3.09,0,0,0-1.23-2.77h0l-.21-.13h0a2.72,2.72,0,0,0-1.86-.07,4.92,4.92,0,0,0-1.07.47A9.64,9.64,0,0,0,53.17,379.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.37,369.86a3.91,3.91,0,0,1,1.94-.6,2.35,2.35,0,0,1,1.23.35l.11.06,2.82,1.62a2.72,2.72,0,0,0-1.86-.07,4.92,4.92,0,0,0-1.07.47,9.64,9.64,0,0,0-4.37,7.55,5.12,5.12,0,0,0,.13,1.15,2.61,2.61,0,0,0,1,1.59l-2.89-1.67,0,0-.25-.15-.07-.05A3.2,3.2,0,0,1,50,377.41,9.61,9.61,0,0,1,54.37,369.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.41,353.84a5,5,0,0,0,.13,1.14,2.61,2.61,0,0,0,1,1.6l0,0a3,3,0,0,0,3.17-.25,9.64,9.64,0,0,0,4.37-7.57,3.09,3.09,0,0,0-1.23-2.76v0l-.21-.12h0a2.72,2.72,0,0,0-1.86-.07,5.14,5.14,0,0,0-1.07.47A9.64,9.64,0,0,0,100.41,353.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.61,344.45a4,4,0,0,1,1.94-.59,2.24,2.24,0,0,1,1.23.35l.11.06,2.82,1.62a2.72,2.72,0,0,0-1.86-.07,5.14,5.14,0,0,0-1.07.47,9.64,9.64,0,0,0-4.37,7.55,5,5,0,0,0,.13,1.14,2.61,2.61,0,0,0,1,1.6l-2.89-1.67-.05,0-.25-.14-.07-.05A3.23,3.23,0,0,1,97.24,352,9.66,9.66,0,0,1,101.61,344.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,389.16a5,5,0,0,1-.13,1.14,2.61,2.61,0,0,1-1,1.6l0,0a3,3,0,0,1-3.17-.25,9.64,9.64,0,0,1-4.37-7.56,3.09,3.09,0,0,1,1.23-2.77h0l.21-.13h0a2.72,2.72,0,0,1,1.86-.07,5.14,5.14,0,0,1,1.07.47A9.64,9.64,0,0,1,92,389.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.79,379.77a4,4,0,0,0-1.94-.59,2.33,2.33,0,0,0-1.23.35l-.11.06-2.82,1.62a2.72,2.72,0,0,1,1.86-.07,5.14,5.14,0,0,1,1.07.47A9.64,9.64,0,0,1,92,389.16a5,5,0,0,1-.13,1.14,2.61,2.61,0,0,1-1,1.6l2.89-1.67,0,0,.25-.15.07-.05a3.23,3.23,0,0,0,1.07-2.68A9.66,9.66,0,0,0,90.79,379.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.65,374.14a5.62,5.62,0,0,1-.12,1.14,2.61,2.61,0,0,1-1,1.6l0,0a3,3,0,0,1-3.17-.25,9.62,9.62,0,0,1-4.37-7.56,3.09,3.09,0,0,1,1.23-2.77h0l.21-.13h0a2.72,2.72,0,0,1,1.86-.07,5.14,5.14,0,0,1,1.07.47A9.63,9.63,0,0,1,122.65,374.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.46,364.75a4,4,0,0,0-1.94-.59,2.3,2.3,0,0,0-1.23.35l-.12.06-2.81,1.62a2.72,2.72,0,0,1,1.86-.07,5.14,5.14,0,0,1,1.07.47,9.63,9.63,0,0,1,4.36,7.55,5.62,5.62,0,0,1-.12,1.14,2.61,2.61,0,0,1-1,1.6l2.89-1.67,0,0,.24-.14.08-.05a3.23,3.23,0,0,0,1.07-2.68A9.66,9.66,0,0,0,121.46,364.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.38,355.72a5,5,0,0,1-.13,1.14,2.61,2.61,0,0,1-1,1.6l0,0a3,3,0,0,1-3.17-.24,9.66,9.66,0,0,1-4.37-7.57,3.11,3.11,0,0,1,1.23-2.77h0l.21-.12h0a2.72,2.72,0,0,1,1.86-.07,4.6,4.6,0,0,1,1.07.46A9.66,9.66,0,0,1,63.38,355.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.18,346.33a4,4,0,0,0-1.94-.59,2.32,2.32,0,0,0-1.23.34l-.11.07-2.82,1.62a2.72,2.72,0,0,1,1.86-.07,4.6,4.6,0,0,1,1.07.46,9.66,9.66,0,0,1,4.37,7.56,5,5,0,0,1-.13,1.14,2.61,2.61,0,0,1-1,1.6l2.89-1.67,0,0,.25-.15.07,0a3.25,3.25,0,0,0,1.07-2.69A9.64,9.64,0,0,0,62.18,346.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.44 346.49 105.03 342.02 105.03 345.35 89.44 354.34 89.44 346.49",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.44 346.49 87.91 345.54 103.55 341.27 105.03 342.02 89.44 346.49",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.7 356.42 60.6 348.14 60.6 344.77 82.7 346.75 82.7 356.42",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.6 344.77 62.22 344.34 84.01 345.75 82.7 346.75 60.6 344.77",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.11,355.36c0,2.5,7.69,2.5,7.69,0V333.5H82.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.87,349.67l4.23,27.45H89.21l-4-27.45A4.75,4.75,0,0,0,87.87,349.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.25 349.67 85.25 357.21 89.21 381.76 89.21 377.12 85.25 349.67",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.21,
    y: 377.12,
    width: 2.89,
    height: 4.65,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.94 356.98 55.43 371.93 55.43 367.32 83.94 349.69 83.94 356.98",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.94,349.69a3.14,3.14,0,0,1-1.83-.83L53.65,366.12l1.78,1.2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.43 371.93 55.43 367.32 53.65 366.12 53.65 370.58 55.43 371.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.87 366.65 89.42 356.22 89.42 349.38 119.87 362.05 119.87 366.65",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.42,349.38c.25-.06.36-.51.38-1.18l31,13.48-.9.37Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.77 361.68 120.77 366.13 119.87 366.65 119.87 362.05 120.77 361.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.21,
    y: 377.12,
    width: 2.89,
    height: 4.65,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.43 371.93 55.43 367.32 53.65 366.12 53.65 370.58 55.43 371.93",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.77 361.68 120.77 366.13 119.87 366.65 119.87 362.05 120.77 361.68",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.46,290.8h-13v49.7c0,3.74,13,3.74,13,0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.65,283.28c0-5.42-3.58-10.85-10.75-15C97.57,260,74.33,260,60,268.3c-7.17,4.13-10.75,9.56-10.75,15v12.16c0,5.43,3.58,10.85,10.75,15,14.33,8.27,37.57,8.27,51.9,0,7.17-4.14,10.75-9.56,10.75-15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,268.3c-7.17,4.14-10.75,9.56-10.75,15s3.59,10.85,10.75,15c14.33,8.28,37.57,8.28,51.9,0,7.17-4.13,10.75-9.56,10.75-15s-3.58-10.84-10.75-15C97.57,260,74.33,260,60,268.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.06,268.88c-6.87,3.83-10.3,8.86-10.3,13.89s3.43,10.05,10.3,13.88c13.75,7.67,36,7.67,49.78,0,6.87-3.83,10.31-8.86,10.31-13.88s-3.44-10.06-10.31-13.89C97.09,261.21,74.81,261.21,61.06,268.88Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.49,406.36c.32,0,.58,3.58-1.26,5-2.11,1.6-8.17,4.07-15.87,2.55s-11.75-4.2-14.68-7-7.05-6.78-10.52-7.79c-3.21-.94-8.4-3.13-9.38-4.21s-.54-5.57-.54-5.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.19,373.69a2.39,2.39,0,0,0-1.35,1.45c-.32,1.22-.43,2.81-1.08,4.82-.9,2.78-1.75,8.55-1.47,10.88s7.23,4.77,10.54,6.29a43.27,43.27,0,0,1,10.56,7.7c3.45,3.26,10.93,6.8,16,7.2,7.71.62,12.85-1.15,14.58-3.84,2.14-3.33,1.42-7-7.19-11.68-1.63-.89-7.31-4.78-9.23-6.19a45.59,45.59,0,0,1-5.75-4.91,33,33,0,0,1-2.54-2.87,12.39,12.39,0,0,1-2.06-3c-.08-.24-.14-.52-.21-.77a13,13,0,0,1-.44-2.13c-.1-.75-.12-1.83-.79-2.33s-11.84,1-12.7,2.16a6.63,6.63,0,0,0-.94,3.18c-.05.52-.08,1-.12,1.56,0,.22.06.63-.25.52s-.57-.91-.66-1.18c-.21-.6-.33-1.23-.56-1.83a5.24,5.24,0,0,0-1-2c-1.4-1.34-2.84-1.19-3.24-1.64C168.3,375.09,168.21,374.13,168.19,373.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.24,396.77c-11.24.05-14.94,8.81-15.7,13.07a26.18,26.18,0,0,0,7.84,2.19c7.71.62,13.17-1.13,14.9-3.82C218.29,405.08,217,400.32,209.24,396.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.73,397.85a.58.58,0,0,1-.34-.15.55.55,0,0,1,0-.78c1.68-1.81,7-5.59,11-4.88a.55.55,0,1,1-.19,1.08c-3.76-.65-8.7,3.12-10,4.55A.55.55,0,0,1,192.73,397.85Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.1,394.71a.55.55,0,0,1-.37-.92c1.69-1.81,7-5.6,11-4.89a.55.55,0,0,1,.44.64.54.54,0,0,1-.63.45c-3.77-.66-8.7,3.11-10,4.55A.54.54,0,0,1,188.1,394.71Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.85,391.2a.52.52,0,0,1-.34-.14.56.56,0,0,1,0-.78c1.68-1.82,7-5.6,11-4.89a.56.56,0,0,1,.45.64.55.55,0,0,1-.63.45c-3.77-.66-8.71,3.11-10,4.55A.55.55,0,0,1,183.85,391.2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.68,387.7a.56.56,0,0,1-.37-.92c2.32-2.58,7.93-5.59,12-4.88a.55.55,0,0,1-.19,1.08c-3.63-.64-8.9,2.25-11,4.54A.54.54,0,0,1,179.68,387.7Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.3,412.45c-.35,5.12-1.18,8.5-3,11.49s-5.26,3.88-8.71,3-7.85-3.32-8.79-7.75-1.49-7.46-.66-12.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.23,375.41c-1.43-.17-1.12,6.88-2,13.76-.95,7.37-2,10.28-2.89,16.32-1,6.9.13,10,2.5,14.21s10.86,8.4,15.13,2.46c3.48-4.84,3.68-10.25,3.44-17.15a99.75,99.75,0,0,1,1.13-17.31c.66-5.57,1.82-10.43.59-11a49,49,0,0,1-1.26,5.36c-.15.39-.71,1.34-.92-.11-.06-.42.08-1.41,0-1.84a1.84,1.84,0,0,0-1.27-1.67,13.75,13.75,0,0,0-6.06-1.4c-2.78,0-5.18-.17-6.74.61-.94.47-.93,1.37-1,2.24-.13,1-.15,1.68-.41,1.47C114,380.91,114.23,375.41,114.23,375.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.88,409.49A17.32,17.32,0,0,0,111.43,420c2.37,4.21,11.55,8.42,15.82,2.49,2.12-3,2.72-6.47,3.05-10.06C127.83,407.81,112.9,405.61,108.88,409.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.27,404.9a.48.48,0,0,1-.17,0c-.06,0-6.62-2.84-13-1.42a.53.53,0,0,1-.63-.41.53.53,0,0,1,.4-.63c6.8-1.49,13.49,1.38,13.74,1.51a.53.53,0,0,1-.29,1Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.42,398.28a.52.52,0,0,1-.44-.36.53.53,0,0,1,.33-.67c6.41-2.1,13.46,1.24,13.73,1.38a.53.53,0,0,1-.5.94c-.06,0-6.93-3.27-12.9-1.31A.55.55,0,0,1,114.42,398.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.7,393.43a.53.53,0,0,1-.12-1c7-2.45,13.74,1.19,14,1.34a.55.55,0,0,1,.17.74.53.53,0,0,1-.73.16c-.06,0-6.52-3.51-13.08-1.24A.47.47,0,0,1,114.7,393.43Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.1,388.65a.52.52,0,0,1-.44-.35.53.53,0,0,1,.32-.68c6.6-2.4,13.8,1.34,14.07,1.5a.53.53,0,0,1,.19.72.51.51,0,0,1-.72.19c-.07,0-7.05-3.64-13.18-1.41A.5.5,0,0,1,115.1,388.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.49,191.77c-6.09,10.72-11,19.76-12.59,48.07-1.79,32-1.52,44.13-1.68,48s-2.68,10.93-4.83,29.93.11,65,.11,65,1.52,3.1,8.92,3.81c6.82.65,10.83-1.71,10.83-1.71S143.1,324.43,145.77,313s10.49-49,10.49-49l2.56,35.87s-2.16,10.47-.2,27.16,7.11,51,7.11,51,1.58,4.57,10.32,5.21c8.55.63,13.72-3.34,13.72-3.34s1.26-72.48,1.4-91.37,1.26-68-4.59-96Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.62,227.7,156.26,264l2.56,35.87V263.6l5.67-29.77c4.64-1.06,15.24-6.45,18.2-14.23C175.5,226.89,162.62,227.7,162.62,227.7Zm-21.53-21.39c.85-3.05,1.73-6.07,2.73-9.12a44.66,44.66,0,0,0-4.24,8.64,83.09,83.09,0,0,0-2.86,9.17c-.75,3.11-1.39,6.24-1.83,9.41a61,61,0,0,0-.71,9.55c.8-3.1,1.54-6.18,2.28-9.26s1.47-6.16,2.26-9.22S140.27,209.36,141.09,206.31ZM136.45,204c1.06-1.86,2.13-3.72,3.11-5.68a34.25,34.25,0,0,0-4.44,4.82,46.59,46.59,0,0,0-3.62,5.43,40.31,40.31,0,0,0-2.76,5.92,25.14,25.14,0,0,0-1.54,6.33l3-5.7c1-1.87,2-3.73,3.09-5.57S135.4,205.85,136.45,204Zm-4.76,121.27q-2.82,14.73-5.24,29.54,3.6-14.58,6.8-29.23c2.17-9.77,4.22-19.52,6.25-29.35s3.21-19.8,4.27-29.74,1.88-19.91,2.57-29.89c-1.47,9.89-2.81,19.8-4.15,29.7s-2.78,19.78-4.71,29.55S133.53,315.44,131.69,325.26Zm50.89-48.7c.17,4.33.4,8.69.3,13s.08,12.56-.18,16.9c0,0-.25,25.54.52,35.21,1.1-8.64,1.34-43.3,1.7-52.07,0-8.8-.65-17.46-1.38-26.15s-1.76-17.35-3.06-26L182,263.53C182.16,267.88,182.41,272.22,182.58,276.56Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127,94.88c.25,3.62,3.52,10.88,6.6,15,2.57,3.44,3.79,5.44,6.94,8.35a2.36,2.36,0,0,0,.73.53,2.25,2.25,0,0,0,.81.12c1.79,0,3.66-.42,5.45-.59,2.44-.22,4.88-.47,7.32-.7a31.69,31.69,0,0,0,5.49-.86,15.81,15.81,0,0,0,11.48-13.34c.27-2.21-.83-5-.13-7.07.34-1,1-1.92,1.35-2.94a16.91,16.91,0,0,0,1-8.64c-1.07-6-5.46-13.47-16.71-14.76-9.93-1.14-24.62,1.75-27,13.12C125.87,85.56,126.73,90.6,127,94.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,125.64c-14.42,11.46-22.73,16.54-24.18,24.71-8.23-3.27-18.9-18.36-18.18-23,9.81-5.84,35.42-23,35.42-23s8.81-26.58,10.63-36.69c1-5.34.85-5.81,2.5-9.35l3.19-.34c.52-.54,3.5-4.27,4.2-3.23a2.35,2.35,0,0,1,.26.7c.51,1.91,2.1,3.44,3.06,5.13a31,31,0,0,1,1.71,4.07c.83,2.09,1.65,4.19,2.46,6.28,0,0-3.06,2.85-4.64,4.07-.48.37-1.17,2.57-1.41,6.42-.63,10.11-1.11,17.15-1.44,26.71C226.35,115.62,224.47,116.56,213,125.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.34,125.93c5.1-2.15,34.13-22,34.13-22L213,80a13.45,13.45,0,0,0,6.8,7.31c5.33,2.61,8.26,1.45,8.26,1.45s-.91,19.09-1.19,23.4-1.38,4.56-7,9.58-22.42,15.86-27,22.38S189,154.4,189,154.4Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.41,78.31a9.87,9.87,0,0,1-3.67-.56,4.4,4.4,0,0,1-2-2.24,3.16,3.16,0,0,0,1.71.95,5.25,5.25,0,0,0,2.3.1A4,4,0,0,0,229.46,75C229.06,75.52,228.74,76.31,228.41,78.31Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.77,57.2c1.85.83,2.33,3.13,2.54,4.94a13.85,13.85,0,0,1-.51,6.68c-.05.11-.12,0-.12-.1a13.76,13.76,0,0,0-.18-3.56c-.11-.9-.25-1.81-.44-2.7a14.4,14.4,0,0,0-.66-2.24,19.41,19.41,0,0,0-1.13-2.17C223.13,57.78,223.35,57,223.77,57.2Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.48,77l0,0h0Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--conical-flask--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.25,57l-2.07-8.68L231,46.26,233,54.92l18.51,23.65a3.18,3.18,0,0,1,.66,1.57v.06c.19,2.28-.93,4.82-3.44,7.2-5.7,5.38-16.39,7.92-23.9,5.68-3.77-1.12-6-3.25-6.6-5.76Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.25,57l-2.07-8.68L231,46.26,233,54.92l18.51,23.65a3.18,3.18,0,0,1,.66,1.57v.06c.19,2.28-.93,4.82-3.44,7.2-5.7,5.38-16.39,7.92-23.9,5.68-3.77-1.12-6-3.25-6.6-5.76C218.24,87.29,224.25,57,224.25,57Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.18,48.33l3.51-.83,2.21,9.29s-2.46,15.24-3.31,20.9.12,14.53,6.74,15a29,29,0,0,0,11.18-1.27c-5.57,2.47-12.41,3.25-17.67,1.68C221.23,92,219,90,218.32,87.63a1.3,1.3,0,0,1,0-.59l5.95-30Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.05,85.93l3.47-18.85,14.68-3.49,11.59,15.26a2.34,2.34,0,0,1,.33.72,2.47,2.47,0,0,1,.07.66v0c.05,1.85-1,3.91-3.16,5.85-5.11,4.57-14.62,6.83-21.25,5.06-2.81-.75-4.66-2.12-5.44-3.78,0,0,0,0,0,0a2.29,2.29,0,0,1-.26-.69s0,0,0,0A2.1,2.1,0,0,1,220.05,85.93Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.05,85.93l3.47-18.85,14.68-3.49,11.59,15.26a2.34,2.34,0,0,1,.33.72,2.47,2.47,0,0,1,.07.66v0c.05,1.85-1,3.91-3.16,5.85-5.11,4.57-14.62,6.83-21.25,5.06-2.81-.75-4.66-2.12-5.44-3.78,0,0,0,0,0,0a2.29,2.29,0,0,1-.26-.69s0,0,0,0A2.1,2.1,0,0,1,220.05,85.93Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.53,77.83a.82.82,0,0,0,.13,1,.88.88,0,0,0,1,.21.82.82,0,0,1-1.17,0A.84.84,0,0,1,238.53,77.83Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.92,77.68a.78.78,0,0,1,.75.23.77.77,0,0,1,.21.56.78.78,0,0,1-.25.54.8.8,0,0,1-.35.19.76.76,0,0,1-.75-.23.73.73,0,0,1-.21-.56.78.78,0,0,1,.25-.54.8.8,0,0,1,.35-.19m0-.05a.82.82,0,0,0-.38.2.84.84,0,0,0,0,1.18.81.81,0,0,0,.8.24.75.75,0,0,0,.37-.2.83.83,0,0,0-.75-1.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M239.16,77.82a.65.65,0,0,1,.59.6s-.06.12-.12.09-.13-.12-.21-.17a.71.71,0,0,0-.24-.06c-.19,0-.29,0-.4-.11S238.79,77.76,239.16,77.82Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.82,78a.13.13,0,0,0,.26,0,.14.14,0,0,0-.14-.12A.12.12,0,0,0,238.82,78Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.94,86.57a1.19,1.19,0,0,0,.17,1.44,1.26,1.26,0,0,0,1.43.3,1.17,1.17,0,0,1-1.67-.06A1.2,1.2,0,0,1,235.94,86.57Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.48,86.36a1.12,1.12,0,0,1,1.37,1.13,1.14,1.14,0,0,1-.36.77,1.06,1.06,0,0,1-.49.26,1.1,1.1,0,0,1-1.07-.33,1,1,0,0,1-.3-.79,1.08,1.08,0,0,1,.36-.77,1.18,1.18,0,0,1,.49-.27m0-.07a1.19,1.19,0,0,0-.59,2,1.17,1.17,0,0,0,1.14.34,1.09,1.09,0,0,0,.53-.28,1.18,1.18,0,0,0-1.08-2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.82,86.57c.49.08.88.45.84.85,0,.06-.09.16-.16.12s-.19-.17-.31-.24a1,1,0,0,0-.34-.09c-.26,0-.41,0-.56-.16S236.31,86.48,236.82,86.57Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.35,86.86a.17.17,0,0,0,.19.17.18.18,0,1,0,0-.35A.17.17,0,0,0,236.35,86.86Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.22,86.65a1.18,1.18,0,0,0,.24,1.42,1.27,1.27,0,0,0,1.45.24,1.18,1.18,0,0,1-1.69-1.66Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.76,86.41a1.11,1.11,0,0,1,1.09,1.85,1.24,1.24,0,0,1-.48.29,1.11,1.11,0,0,1-1.09-1.85,1.24,1.24,0,0,1,.48-.29m0-.07a1.27,1.27,0,0,0-.52.31,1.18,1.18,0,0,0,0,1.67,1.2,1.2,0,0,0,1.16.3,1.27,1.27,0,0,0,.52-.31,1.18,1.18,0,0,0,0-1.67,1.21,1.21,0,0,0-1.16-.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.1,86.6c.5.06.9.41.88.81,0,.07-.08.17-.15.13s-.2-.16-.32-.22a1.05,1.05,0,0,0-.35-.08c-.25,0-.4.05-.56-.13S224.59,86.54,225.1,86.6Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.65,86.92a.17.17,0,0,0,.19.16.18.18,0,0,0,.16-.19.19.19,0,0,0-.19-.17A.18.18,0,0,0,224.65,86.92Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.38,82.45a.51.51,0,0,0,.08.62.54.54,0,0,0,.62.13.51.51,0,1,1-.7-.75Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.62,82.36a.47.47,0,0,1,.46.14.49.49,0,0,1,0,.68.48.48,0,0,1-.22.12.47.47,0,0,1-.46-.15.48.48,0,0,1,.24-.79m0,0a.57.57,0,0,0-.23.12.51.51,0,0,0,.47.88.49.49,0,0,0,.23-.13.51.51,0,0,0,0-.72.53.53,0,0,0-.5-.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.76,82.45c.22,0,.39.19.37.37,0,0,0,.07-.07.05s-.08-.08-.14-.1a.37.37,0,0,0-.14,0c-.11,0-.18,0-.24-.07S233.54,82.41,233.76,82.45Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.56,82.58a.08.08,0,0,0,.08.07.09.09,0,0,0,.08-.08.08.08,0,0,0-.09-.07A.07.07,0,0,0,233.56,82.58Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.3,72.19a.72.72,0,0,0,.1.88.8.8,0,0,0,.88.19.73.73,0,0,1-1-1.07Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.63,72.07a.67.67,0,0,1,.61,1.15.59.59,0,0,1-.3.16.67.67,0,0,1-.61-1.15.59.59,0,0,1,.3-.16m0,0a.76.76,0,0,0-.32.17.72.72,0,0,0,.65,1.24.87.87,0,0,0,.33-.17.74.74,0,0,0,0-1,.75.75,0,0,0-.7-.21Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M239.83,72.19c.3,0,.54.28.52.52,0,0,0,.1-.1.07s-.12-.1-.19-.14a.51.51,0,0,0-.21-.06c-.15,0-.25,0-.34-.09S239.52,72.14,239.83,72.19Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.55,72.37a.11.11,0,0,0,.11.11.13.13,0,0,0,.11-.12.11.11,0,0,0-.12-.1A.1.1,0,0,0,239.55,72.37Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.87,83a.44.44,0,0,0,.09.53.49.49,0,0,0,.54.09.45.45,0,0,1-.63,0A.44.44,0,0,1,228.87,83Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.07,82.89a.42.42,0,0,1,.41.69.4.4,0,0,1-.18.1.41.41,0,0,1-.53-.39.38.38,0,0,1,.12-.29.42.42,0,0,1,.18-.11m0,0a.45.45,0,0,0-.19.74.45.45,0,0,0,.44.11.52.52,0,0,0,.19-.11.44.44,0,0,0,0-.63.45.45,0,0,0-.43-.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.2,83a.34.34,0,0,1,.33.3s0,.06-.06,0a1.25,1.25,0,0,0-.12-.08.31.31,0,0,0-.13,0c-.09,0-.15,0-.21,0S229,82.94,229.2,83Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,83.08s0,.06.07.06.07,0,.06-.08a.07.07,0,0,0-.07-.06A.08.08,0,0,0,229,83.08Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.34,72.58a.49.49,0,0,0,.07.61.53.53,0,0,0,.61.13.5.5,0,1,1-.68-.74Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.57,72.49a.49.49,0,0,1,.46.14.48.48,0,0,1,0,.67.53.53,0,0,1-.21.11.47.47,0,0,1-.46-.14.46.46,0,0,1-.12-.34.48.48,0,0,1,.15-.33.53.53,0,0,1,.21-.11m0,0a.48.48,0,0,0-.22.12.51.51,0,0,0,0,.72.53.53,0,0,0,.49.14.48.48,0,0,0,.22-.12.5.5,0,0,0,0-.71.51.51,0,0,0-.49-.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.71,72.58c.21,0,.38.19.36.36s0,.07-.07,0l-.13-.1a.37.37,0,0,0-.14,0c-.11,0-.18,0-.24-.06S225.5,72.54,225.71,72.58Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.51,72.7s0,.08.08.08a.08.08,0,0,0,.08-.08s0-.08-.08-.08S225.51,72.66,225.51,72.7Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.75,79.22a1,1,0,0,0,.15,1.24,1.1,1.1,0,0,0,1.24.27,1,1,0,0,1-1.39-1.51Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.22,79a1,1,0,0,1,.87,1.64,1,1,0,0,1-.43.23.94.94,0,0,1-.92-.29.91.91,0,0,1-.26-.68.94.94,0,0,1,.31-.67,1,1,0,0,1,.43-.23m0-.06a1,1,0,0,0-.45.24,1,1,0,0,0-.06,1.45,1,1,0,0,0,1,.3,1.13,1.13,0,0,0,.46-.24,1,1,0,0,0,.05-1.45,1,1,0,0,0-1-.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.51,79.21a.79.79,0,0,1,.73.74c0,.06-.08.14-.14.1s-.16-.14-.27-.2a.74.74,0,0,0-.29-.08c-.23,0-.36,0-.49-.13S245.07,79.14,245.51,79.21Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.1,79.47a.16.16,0,0,0,.16.15.16.16,0,0,0,.15-.16.15.15,0,0,0-.16-.15A.16.16,0,0,0,245.1,79.47Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.83,80a.84.84,0,0,0,.5.9.91.91,0,0,0,1-.18.85.85,0,0,1-1.53-.72Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.41,79.63a.77.77,0,0,1,.52.05.79.79,0,0,1,.41.45.78.78,0,0,1,0,.6.81.81,0,0,1-.53.44.84.84,0,0,1-.52,0,.79.79,0,0,1-.38-1.06.77.77,0,0,1,.53-.43m0-.06a.86.86,0,0,0-.57.47.83.83,0,0,0,.41,1.12.81.81,0,0,0,.55.06.84.84,0,0,0,.16-1.59.88.88,0,0,0-.55-.06Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.41,79.8a.65.65,0,0,1,.79.33c0,.05,0,.13-.08.12a2.44,2.44,0,0,0-.26-.06.74.74,0,0,0-.26,0c-.17.07-.26.14-.41.05S224.05,79.88,224.41,79.8Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.18,80.12a.13.13,0,0,0,.17.06.13.13,0,0,0-.11-.23A.13.13,0,0,0,224.18,80.12Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.84,78.14a.6.6,0,0,0,.35.63.63.63,0,0,0,.72-.13.58.58,0,0,1-.78.29A.59.59,0,0,1,228.84,78.14Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.25,77.85a.5.5,0,0,1,.36,0,.55.55,0,0,1-.1,1,.53.53,0,0,1-.37,0,.56.56,0,0,1-.26-.74.54.54,0,0,1,.37-.3m0,0a.6.6,0,0,0-.4.33.59.59,0,0,0,.29.79.56.56,0,0,0,.38,0,.6.6,0,0,0,.4-.33.59.59,0,0,0-.67-.83Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.25,78a.45.45,0,0,1,.55.23s0,.1-.05.09l-.19-.05a.55.55,0,0,0-.18,0c-.12,0-.18.09-.28,0S229,78,229.25,78Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.09,78.19a.09.09,0,0,0,.12,0,.09.09,0,0,0-.08-.16A.08.08,0,0,0,229.09,78.19Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.83,71.44a.6.6,0,0,0,.36.63.62.62,0,0,0,.72-.13.59.59,0,0,1-.79.29A.6.6,0,0,1,233.83,71.44Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.24,71.15a.59.59,0,0,1,.37,0,.56.56,0,1,1-.74.27.55.55,0,0,1,.37-.31m0,0a.58.58,0,0,0-.4.32.6.6,0,0,0,.29.79.59.59,0,0,0,.39,0,.6.6,0,0,0,.4-.33.59.59,0,0,0-.68-.82Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234.24,71.27a.45.45,0,0,1,.55.24s0,.09,0,.08l-.19,0a.5.5,0,0,0-.17,0c-.12,0-.19.1-.29,0S234,71.33,234.24,71.27Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.08,71.5a.09.09,0,1,0,0-.12A.09.09,0,0,0,234.08,71.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.24,76.39a.31.31,0,0,0,0,.37.33.33,0,0,0,.38.08.31.31,0,0,1-.44,0A.29.29,0,0,1,234.24,76.39Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.38,76.33a.3.3,0,0,1,.36.29.35.35,0,0,1-.1.21.26.26,0,0,1-.13.06.27.27,0,0,1-.28-.08.3.3,0,0,1,0-.41.33.33,0,0,1,.13-.07m0,0a.39.39,0,0,0-.14.08.29.29,0,0,0,0,.43.29.29,0,0,0,.3.09.27.27,0,0,0,.14-.07.31.31,0,0,0-.28-.53Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234.47,76.38c.13,0,.23.12.22.23s0,0,0,0-.05,0-.09-.06l-.08,0c-.07,0-.11,0-.15,0S234.33,76.36,234.47,76.38Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.35,76.46a0,0,0,0,0,0,.05.05.05,0,0,0,.05-.05,0,0,0,0,0-.05,0S234.34,76.44,234.35,76.46Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.1,82.81a.3.3,0,0,0,.05.37.32.32,0,0,0,.37.08.31.31,0,0,1-.44,0A.3.3,0,0,1,240.1,82.81Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.24,82.75a.3.3,0,0,1,.28.09.3.3,0,0,1,.08.21.4.4,0,0,1-.09.2l-.13.07a.29.29,0,0,1-.28-.09.3.3,0,0,1,0-.41.33.33,0,0,1,.13-.07m0,0a.39.39,0,0,0-.14.08.3.3,0,0,0,0,.43.29.29,0,0,0,.3.09.27.27,0,0,0,.14-.07.32.32,0,0,0,0-.44.34.34,0,0,0-.3-.09Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M240.33,82.81c.13,0,.23.11.22.22s0,0,0,0,0,0-.08-.06l-.09,0c-.07,0-.11,0-.15,0S240.2,82.78,240.33,82.81Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.21,82.88a0,0,0,0,0,0,.05s0,0,0-.05a0,0,0,0,0-.05,0A.07.07,0,0,0,240.21,82.88Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.63,73.08a.3.3,0,0,0,.05.37.32.32,0,0,0,.37.08.29.29,0,0,1-.43,0A.3.3,0,0,1,229.63,73.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.77,73a.29.29,0,0,1,.28.09.26.26,0,0,1,.08.2.33.33,0,0,1-.09.21.31.31,0,0,1-.13.06.27.27,0,0,1-.28-.08.29.29,0,0,1,0-.41.29.29,0,0,1,.12-.07m0,0a.29.29,0,0,0-.14.08.3.3,0,0,0,0,.43.27.27,0,0,0,.29.09.27.27,0,0,0,.14-.07.31.31,0,0,0,0-.44.33.33,0,0,0-.3-.09Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.86,73.07c.13,0,.23.12.22.23s0,0,0,0,0,0-.08-.06a.16.16,0,0,0-.09,0c-.07,0-.11,0-.15,0S229.73,73.05,229.86,73.07Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.74,73.15a0,0,0,0,0,0,0s0,0,0,0a0,0,0,0,0-.05-.05S229.74,73.13,229.74,73.15Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.08,67.61a.33.33,0,0,0,0,.38.34.34,0,0,0,.37.08.3.3,0,0,1-.43,0A.31.31,0,0,1,239.08,67.61Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.23,67.56a.3.3,0,0,1,.28.09.25.25,0,0,1,.07.2.25.25,0,0,1-.09.2.24.24,0,0,1-.13.07.29.29,0,0,1-.28-.08.29.29,0,0,1,0-.41.27.27,0,0,1,.13-.07m0,0a.37.37,0,0,0-.14.07.31.31,0,0,0,0,.44.29.29,0,0,0,.3.09.24.24,0,0,0,.13-.07.31.31,0,0,0,0-.44.33.33,0,0,0-.3-.09Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M239.31,67.61c.13,0,.23.12.22.22s0,0,0,0-.05-.05-.08-.06a.14.14,0,0,0-.09,0c-.07,0-.1,0-.14,0S239.18,67.59,239.31,67.61Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.19,67.69s0,0,.05,0,0,0,0,0a0,0,0,0,0,0,0A0,0,0,0,0,239.19,67.69Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.18,75.31a.31.31,0,0,0,0,.37.32.32,0,0,0,.37.08.3.3,0,0,1-.41-.45Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.32,75.25a.3.3,0,0,1,.28.09.27.27,0,0,1,.07.21.27.27,0,0,1-.09.2.33.33,0,0,1-.13.07.3.3,0,0,1-.28-.09.29.29,0,0,1,0-.41l.13-.07m0,0a.35.35,0,0,0-.13.08.29.29,0,0,0,0,.43.31.31,0,0,0,.3.1.35.35,0,0,0,.13-.08.29.29,0,0,0,0-.43.31.31,0,0,0-.3-.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M244.41,75.31a.23.23,0,0,1,.21.22s0,0,0,0l-.08-.06a.24.24,0,0,0-.09,0c-.06,0-.1,0-.14,0S244.27,75.28,244.41,75.31Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.28,75.38a.05.05,0,0,0,.05.05,0,0,0,0,0,0-.05s0,0,0,0A0,0,0,0,0,244.28,75.38Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.07,86.68a2.1,2.1,0,0,1,0-.75l3.47-18.85,2.84-.68c-.67,4.19-1.38,8.72-1.77,11.29-.62,4.21-1.19,10.42,1.28,13.51l-.09,0c-2.81-.75-4.66-2.12-5.44-3.78,0,0,0,0,0,0a2.29,2.29,0,0,1-.26-.69S220.06,86.68,220.07,86.68Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.7,62.69a12.42,12.42,0,0,1,7.9-.87c3.23.9,3.84,3.46,1.36,5.72A12.5,12.5,0,0,1,226.48,70c-3.32-.88-3.93-3.44-1.36-5.72a10.11,10.11,0,0,1,2.58-1.62",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.7,62.69a12.42,12.42,0,0,1,7.9-.87c3.23.9,3.84,3.46,1.36,5.72A12.5,12.5,0,0,1,226.48,70c-3.32-.88-3.93-3.44-1.36-5.72a10.11,10.11,0,0,1,2.58-1.62",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.41,69.65a5.82,5.82,0,0,0,1.07.38A12.54,12.54,0,0,0,237,67.54c2.48-2.26,1.87-4.82-1.36-5.72a9.33,9.33,0,0,0-3-.3,6.24,6.24,0,0,1,2.31,1c.47.32,1.67,1.26,1.1,1.92a1.45,1.45,0,0,1-.66.38l-1.27.45a2.36,2.36,0,0,0-.79.4.83.83,0,0,0-.32.78c.07.3.34.5.47.78a1.16,1.16,0,0,1-.15,1.16c-.76,1-2.6,1.39-3.78,1.59A7.47,7.47,0,0,1,225.41,69.65Zm8.33-3.47c-.11-.39.68-.54.94-.56a.82.82,0,0,1,.22,0,.24.24,0,0,1,.15.16.26.26,0,0,1-.07.2,1.36,1.36,0,0,1-1,.36A.27.27,0,0,1,233.74,66.18Z",
    style: {
      fill: "#fff",
      mixBlendMode: "hard-light",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.31,68.19a1.1,1.1,0,0,0,.94,0,.33.33,0,0,0,.21-.15c.13-.22-.09-.38-.27-.44a1,1,0,0,0-.69,0C231.22,67.77,231.08,68.05,231.31,68.19Zm-.83.41a.16.16,0,0,0,.12.12.36.36,0,0,0,.25,0,.12.12,0,0,0,.07-.11.18.18,0,0,0,0-.07C230.77,68.42,230.44,68.39,230.48,68.6Z",
    style: {
      fill: "#fff",
      mixBlendMode: "hard-light",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.69 49.37 223.01 49.33 224.95 57.23 222.21 78.13 225.57 57.26 223.69 49.37",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.52,57l-2.18-9.28a9.9,9.9,0,0,0,1.82-.87l2.09,8.8L250.1,77.94a3.8,3.8,0,0,1,.56,4.22A14.86,14.86,0,0,1,248,86.22a19.52,19.52,0,0,1-6.46,4.23s4.27-3.71,4.77-5.86c.38-1.6-.23-4.17-3.17-9S230.52,57,230.52,57Z",
    style: {
      fill: "#fff",
      mixBlendMode: "hard-light",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.74,50.59l-.7-2.92,8.74-2.06.69,2.9A4.24,4.24,0,0,1,231,49a8.68,8.68,0,0,1-7.63,1.81A4.75,4.75,0,0,1,222.74,50.59Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.58,43.94a2.33,2.33,0,0,0-1.78-1.54,7.3,7.3,0,0,0-6.43,1.53,2.31,2.31,0,0,0-.89,2.17h0l.46,2h0a2.33,2.33,0,0,0,1.78,1.54,7.3,7.3,0,0,0,6.43-1.53A2.32,2.32,0,0,0,231,45.9h0l-.46-2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.58,43.94a2.33,2.33,0,0,0-1.78-1.54,7.3,7.3,0,0,0-6.43,1.53,2.31,2.31,0,0,0-.89,2.17h0l.46,2h0a2.33,2.33,0,0,0,1.78,1.54,7.3,7.3,0,0,0,6.43-1.53A2.32,2.32,0,0,0,231,45.9h0l-.46-2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.41,47.82a8.08,8.08,0,0,1-5.07,1.59c-1.54-.26-2.38-.69-2.7-2l-.71-3a2,2,0,0,0-.45,1.69h0l.46,2h0a2.33,2.33,0,0,0,1.78,1.54,7.3,7.3,0,0,0,6.43-1.53C230.24,48,230.33,47.91,230.41,47.82Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.25,47.64a7.3,7.3,0,0,0,6.44-1.53c1.53-1.45,1.13-3.11-.89-3.71a7.3,7.3,0,0,0-6.43,1.53C220.83,45.38,221.23,47,223.25,47.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.25,47.64a7.3,7.3,0,0,0,6.44-1.53c1.53-1.45,1.13-3.11-.89-3.71a7.3,7.3,0,0,0-6.43,1.53C220.83,45.38,221.23,47,223.25,47.64Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.24,43.86c-1.63.84-1.91,2.19-.93,3s2.6,1.2,5.11.27,2.73-2.34,2.66-2.65Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.58,47.19a6.9,6.9,0,0,0,5.66-1.34c1.36-1.21,1-2.57-.72-3a6.86,6.86,0,0,0-5.66,1.35C221.49,45.37,221.81,46.73,223.58,47.19Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.58,47.19a6.9,6.9,0,0,0,5.66-1.34c1.36-1.21,1-2.57-.72-3a6.86,6.86,0,0,0-5.66,1.35C221.49,45.37,221.81,46.73,223.58,47.19Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.48,46.78a2.51,2.51,0,0,0-.28.29,3.4,3.4,0,0,0,.38.12,6.9,6.9,0,0,0,5.66-1.34,3.76,3.76,0,0,0,.28-.29,3.4,3.4,0,0,0-.38-.12A6.89,6.89,0,0,0,223.48,46.78Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.6,49,233,54.92l9,11.54a5.51,5.51,0,0,1,.31-.6,4,4,0,0,0,.39-2.58,12,12,0,0,1-2-1.29A25.84,25.84,0,0,1,237,57.45c-.63-1-2.5-4-2.49-6.09,0-2.81.22-3.92-.38-5.12A10,10,0,0,1,231.6,49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.17,52.18l-.5.39-.08.06a9.83,9.83,0,0,0-2.15,2.12c-.21.33-.36.71-.58,1a3.92,3.92,0,0,0-.59,1.15,15.83,15.83,0,0,0-.34,3.36c-.05.72-.38,1.84.45,2.24a4.47,4.47,0,0,0,2.09.09c.15.54,0,1.11.08,1.65a2.8,2.8,0,0,0,.63,1.25,2.34,2.34,0,0,0,3-.3A2.61,2.61,0,0,0,238,67.05a1.65,1.65,0,0,0,1.63-.65c.67-.73,1.25-1.87,1.8-2.45C238.43,58.76,235.41,54.32,234.17,52.18Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.5,46.12c.58,1.36-.06,2.12-.63,3.18s-2.29,2.42-3.15,1.81-.91-2.15-.22-3.89,1.28-2.47,1.89-2.49A2.85,2.85,0,0,1,234.5,46.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.5,63.67a1.49,1.49,0,0,0,1.73.8,2.49,2.49,0,0,0,1.35-.65c.19.93.48,1.89,1.52,2.15,1.9.48,2.82-2.92,4.7-2.16a9.38,9.38,0,0,0-.07-1.4,3.86,3.86,0,0,0-.26-.94,6,6,0,0,0-.41-.69l-.21-.28a6.81,6.81,0,0,0-.95-.83,1.62,1.62,0,0,1-.36-1.11,2.56,2.56,0,0,0-.56-1.37c-.62-.78-1.75-1.12-1.89-2.19-.06-.52.15-.91.13-1.41a3.83,3.83,0,0,0-1.35-2.82c-.73-.55-2.15.46-2.78.85a16.71,16.71,0,0,0-1.73,1.44,4.77,4.77,0,0,0-1.6,2,16.1,16.1,0,0,0-.46,4.11c-.05.63-.06,1.21.45,1.59a2,2,0,0,0,1.62.39,2.82,2.82,0,0,0,1.1-.57C233.33,61.84,233,62.73,233.5,63.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.92,50.23c-.34.27-.19,1.84-.59,3.82-.33,1.58-1.5,3.38-2.11,4.82-1.36,3.26-.56,7.52-1.72,12.65L222,68.14c.48-2.43,1.08-4.72,1.26-6.27.13-1,.51-2.56.64-3.31a18.94,18.94,0,0,0,.46-4.91C224.2,50.93,222.23,49.2,220.92,50.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Chest--inject-103",
    d: "M123.43,211.12c-3.57-2.89.56-11.59,1.84-29.15.33-4.52-1.22-15.74-1.22-15.74s6.67-9.78,4-31.63l15.3-4.39,21.09.16,8.25,2.4c2.8,2.47,7.93,6.36,12,12.27,5.87,8.52,6.76,17.78.43,24.55-.1,1.34,1.35,16.92,1.92,22.18.8,7.3,4.51,14.68.27,18.28C174.91,220.56,140.22,222.11,123.43,211.12Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.6,115a7,7,0,0,1-6.4-1.79c-3.57-3.24-4.18-6.8-2.87-9.32,1.08-2.08,4.06-3.6,6.33-2.46,2.43,1.22,2.61,2.38,3.62,3.91.89,1.35,2.19-.33,2.45-1.3a5.61,5.61,0,0,0,.08-1.83c-.1-1.29-.24-2.59-.43-3.87a13.47,13.47,0,0,0,3.88-2.51c2.7-2.67,3-7.47,2.43-11,5.22,1.62,11.18,2.43,16.51,1-.28-.58-.55-1.16-.83-1.75a34.92,34.92,0,0,0,5.22,2c1.7.5,2.63.34,3.23,2.08a60.6,60.6,0,0,1,2.25,9.11c2.09,11.59.71,19.55-1.83,22.27-1.74,1.87-5.16,3.32-9.36,3.45l.4,4.4s13.16,11.34-2.36,11.55a24.38,24.38,0,0,1-18.3-8.22L140,113S139.86,114.4,137.6,115Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.74,110.78a3.45,3.45,0,0,1-3.82,3,3.4,3.4,0,0,1-3-3.74Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,111.15a3.4,3.4,0,0,0,3,2.63,3.81,3.81,0,0,0,1.22-.09A3.49,3.49,0,0,0,156,111.15Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.12,90.19l-4.58-1.06a2.28,2.28,0,0,1,2.77-1.76A2.41,2.41,0,0,1,169.12,90.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.58,90.32l-4.22,2.73a2.36,2.36,0,0,1,.64-3.4A2.68,2.68,0,0,1,152.58,90.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.13,89.55l-.89.07c-2.85.26-6.51.88-8.57,1.93-2.59,1.33-3.36,2.41-4.89,2.71s-2.85-.38-6-.61c-2.48-.18-6.36.65-9.28,1.52l-.91.27a1.4,1.4,0,0,0-.71,1.66,3.52,3.52,0,0,0,1.26,1.52,2.11,2.11,0,0,1,.45.62c.57,1.11,1.26,3.32,2.14,4.45a6.46,6.46,0,0,0,1.55,1.45,6,6,0,0,0,.71.38l.4.15a6,6,0,0,0,1.14.27l.18,0,.29,0h.31c.29,0,.61,0,.94,0l.4,0,.49-.08c3.79-.72,5-2.74,5.56-4.69s-.23-4.4,1.51-4.73l.17,0h.16c1.36,0,1.7,2.36,2.87,3.85a7.17,7.17,0,0,0,1.63,1.57l.36.22.18.1.2.1.17.07.19.08.14,0,.11,0a5.72,5.72,0,0,0,1.63.28h.15a8.1,8.1,0,0,0,1.88-.18c3.54-.69,4.34-2.91,4.64-4.27a28.58,28.58,0,0,0,.07-4.88,1.26,1.26,0,0,1,.19-.67,3.16,3.16,0,0,0,.42-1.88C175.28,90.11,174.62,89.52,174.13,89.55ZM157.38,99.67a5.11,5.11,0,0,1-.77,2.72h0a5.4,5.4,0,0,1-3.82,2.2,4.92,4.92,0,0,1-4.36-1,7,7,0,0,1-1.66-2.39c-.56-1.18-1.43-3.54-.9-4.21s2.13-1.58,5-1.86c1.81-.13,4.08-.16,5.62.84C157.22,96.59,157.4,98.23,157.38,99.67ZM173.72,96c0,1,0,3.18-1.8,4.47a5.05,5.05,0,0,1-2,.84,4.9,4.9,0,0,1-4.62-1,5.87,5.87,0,0,1-1.3-1.85c-.58-1.32-1.09-2.89-.72-3.75s2.26-2.1,4.22-2.72a13,13,0,0,1,1.27-.35,8,8,0,0,1,3.26-.1,2.76,2.76,0,0,1,.79.28C173.54,92.18,173.73,94.68,173.72,96Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.64,103.5l-6.07,3.71-2.6-8c.06-1.25.11-2.55,1.16-2.81Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.32,95.87l-9.66,5.59a11.29,11.29,0,0,1,1.66,1.1l8.44-4.67Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.58,95.49c.52,1-.13,1.4-1.06,1.9s-1.76.85-2.28-.11a1.9,1.9,0,1,1,3.34-1.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.11,95.17a4.79,4.79,0,0,1,1.33-.73,3.71,3.71,0,0,1,1.43-.31,4.52,4.52,0,0,1,1.55.19s.09.11,0,.12c-.41,0-.77,0-1.34.08a6.82,6.82,0,0,0-1.6.46,7,7,0,0,0-1.73,1c-.17.13-.51.39-.54.43s-.12-.09-.1-.14A3.33,3.33,0,0,1,166.11,95.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.78,99c-.06,1.08.72,1.21,1.77,1.27s1.95,0,2-1.06a1.9,1.9,0,1,0-3.79-.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.8,97.27a4.82,4.82,0,0,0-1.51-.11,4,4,0,0,0-1.44.32,4.75,4.75,0,0,0-1.32.83s0,.14,0,.12a9.92,9.92,0,0,1,1.25-.49,7.53,7.53,0,0,1,3.62-.09c.21,0,.63.13.67.15s.07-.13,0-.17A3.15,3.15,0,0,0,153.8,97.27Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M161.88,123c-6,.3-14.32-1.11-16.81-4.75,1.55,4,6,5.78,9.46,6.43a36.1,36.1,0,0,0,7.5.62Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.5,129.29s6.57,11.3,6.34,30.92-2.52,78.69-3.76,108.38c-20.28-1.19-29.79-9.43-29.79-9.43s1.74-21.12,3.13-39.3c1.42-18.71,5-28.12,4.12-40.49C119,144.1,128,134.6,128,134.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,125.72l.25,1.63s15.88,12.8,18.75,27.06,5.56,113,5.56,113,5.81-1.37,9.34-4.22c-2.54-36.5-7.69-94.28-7.69-94.28a20.07,20.07,0,0,0,3.13-11.23c-.21-6.52-7.71-22.37-20-31.74A30.57,30.57,0,0,1,162,125.72Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.59,186.92c2.11-12.07,3.43-26.28,3.43-26.28L184.65,157h2.95s-4.56-12.75-10.23-20.17S162,124.05,162,124.05l.33,3.3s12.58,12.79,15.9,23S183.59,186.92,183.59,186.92Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.23,126.49a19.39,19.39,0,0,0-4,2.37,14.24,14.24,0,0,0-3.81,3.58l7,27.48,2.88-.83-2.22,5.62,6.15,19.82s1.5-21.2,1-33.73a45.05,45.05,0,0,0-6.69-21.51Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.23 159.01 163.98 172.7 152.55 229.89 195.53 215.7 209.23 159.01",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.44,202.15a.56.56,0,0,0-.44-.1c-5.27.27-10.36,2.25-15.64,2.44a4.49,4.49,0,0,0-1.79.29l-2.35,11.77a5.24,5.24,0,0,0,.88.08,18.94,18.94,0,0,0,2.26,0,29,29,0,0,0,6-.69,9.75,9.75,0,0,0,5.15-3,11.83,11.83,0,0,1,1.33-1.58c.7-.59,1.63-.88,2.28-1.53a4.92,4.92,0,0,0,1.13-3.28,2.5,2.5,0,0,1,.2-1.06,1.32,1.32,0,0,1,.16-.25c.1-.14.23-.28.34-.42a2.93,2.93,0,0,0,.57-2.34A.44.44,0,0,0,175.44,202.15Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.66,167.79s.14-.79.32-1.76-2.51-.91-6,.13l-6.66,2c-3.49,1-6.45,2.66-6.62,3.63l-.32,1.76Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.59,161.1c.11-.61-1-.73-2.44-.27l-2.64.84s.66-3.8-5.21-2.27-7,5.86-7,5.86l-2.82.91c-1.55.5-2.95,1.4-3.11,2l-.29,1.16,23.3-7S198.48,161.7,198.59,161.1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.59,161.1c.11-.61-1-.73-2.44-.27l-2.64.84s.66-3.8-5.21-2.27-7,5.86-7,5.86l-2.82.91c-1.55.5-2.95,1.4-3.11,2l-.29,1.16,23.3-7S198.48,161.7,198.59,161.1Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,171.94c.14-.81,2.22-2.07,4.92-3.07,0-.1,0-.2,0-.28.14-.84-.34-1.22-2-.73l-.06-.76,16.17-4.75-.15.7c-2.14.6-3.54,1-3.8,2.46,0,.12,0,.22-.06.34,2.55-.55,4.34-.46,4.2.33-.18,1-.32,1.76-.32,1.76l-19.28,5.75Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,171.94c.14-.81,2.22-2.07,4.92-3.07,0-.1,0-.2,0-.28.14-.84-.34-1.22-2-.73l-.06-.76,16.17-4.75-.15.7c-2.14.6-3.54,1-3.8,2.46,0,.12,0,.22-.06.34,2.55-.55,4.34-.46,4.2.33-.18,1-.32,1.76-.32,1.76l-19.28,5.75Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,188.77a66.35,66.35,0,0,1,3.15-12.7l18.94,8.34s4,2.1,13.25,6.51c5,2.39,9.49,4.17,13.86,3.28,1.29-.26,5.7-.87,7-1s2.74-.16,4.17-.2c.92,0,2.54,0,2.54,0l-1,4.9c-.33.17-.69.33-.8.4-.56.37-.52,1,.3,1.37a18.85,18.85,0,0,0,7.48,1.29,43.87,43.87,0,0,0,7.57-.93,4.56,4.56,0,0,1,1.32-.13,1.55,1.55,0,0,1,1.14.59,1.6,1.6,0,0,1-.07,1.67,6.07,6.07,0,0,1-1.22,1.26,3.33,3.33,0,0,0-1.07,1.37c-.27.81,0,1.76-.38,2.52s-1.61,1.13-2.39,1.75a11.23,11.23,0,0,0-1.6,2.06,7.33,7.33,0,0,1-3.33,2.29c-3.63,1.35-7.29,1-11,.48-7.82-1-13.73-4-17.49-5.19s-8.53-2-19.75-5.1c-9.15-2.52-11.64-3.43-15-4.76C98.64,197.28,96.22,195.08,97,188.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.78,182.34c2.23-7.2,5.25-16.41,8.62-25.36a118,118,0,0,1,5.42-13.19c2.92-6,9.4-7.46,16.3-9.53a32.87,32.87,0,0,1,2,25.1C127.75,167,119.7,184,119.7,184l15.15,7.84a19.54,19.54,0,0,0-4.88,6.4c-2.07,4.22.49,9.27.49,9.27s-15.25-4.27-21-5.64-11.08-4.49-12.58-6.8S95.55,189.54,97.78,182.34Z",
    style: {
      fill: "#e6e6e6"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChemistAmico1);
export default __webpack_public_path__ + "static/media/chemist-amico (1).2ad38e2afad68558f100c16bd8719d31.svg";
export { ForwardRef as ReactComponent };